"use client";

import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import saveSurveyResult from "../utils/saveSurveyResult";
import uploadSurveyCameraRecording from "../utils/uploadSurveyCameraRecording";

const RAW = {"INTRO":{"base":"Все респонденты","instruction":"Перед началом каждого интервью зафиксировать время и дату интервью.","ru":"Здравствуйте. Мы представляем ТОО «FusionLab» (ФьюжнЛаб) – независимую компанию, занимающуюся маркетинговыми исследованиями. Мы проводим опрос о заболеваниях желудочно-кишечного тракта среди населения Республики Казахстан.\n\nМогли бы Вы уделить нам 10 минут Вашего времени?\n\nИнформация, которую Вы нам предоставите, строго конфиденциальна и будет использована только в обобщенном виде.","en":"Hello. We represent FusionLab LLP, an independent marketing research company. We are conducting a survey among residents of the Republic of Kazakhstan about gastrointestinal conditions.\n\nCould you spare approximately 10 minutes of your time?\n\nThe information you provide will be kept strictly confidential and used only in aggregated form."},"Q0":{"base":"Все респонденты","instruction":"SINGLE. Если код 2 — завершить интервью.","ru":"Согласны ли Вы принять участие в интервью?\n1. Да\n2. Нет","en":"Do you agree to take part in the interview?\n1. Yes\n2. No"},"S11":{"base":"Все респонденты","instruction":"MULTI. Зачитать. Если отмечен любой код 1–10 — завершить интервью; код 11 — продолжить.","ru":"Работаете ли Вы в одной из следующих отраслей?\n1. Рекламное агентство или агентство по связям с общественностью\n2. Маркетинг / маркетинговые исследования\n3. Газета или журнал, радио или ТВ\n4. Психология или социология\n5. PR (связи с общественностью)\n6. Мерчендайзинг, продвижение медицинских препаратов\n7. Фармакология / фармацевтика\n8. Здравоохранение (медицинские работники, медицинские представители)\n9. Аптека (фармацевты, провизоры)\n10. Дистрибуция медицинских препаратов\n11. Ничего из перечисленного","en":"Do you work in any of the following industries?\n1. Advertising agency or public relations agency\n2. Marketing / marketing research\n3. Newspaper or magazine, radio or television\n4. Psychology or sociology\n5. PR / public relations\n6. Merchandising or promotion of medicines\n7. Pharmacology / pharmaceuticals\n8. Healthcare (healthcare professionals, medical representatives)\n9. Pharmacy (pharmacists)\n10. Distribution of medicines\n11. None of the above"},"S1":{"base":"Все респонденты","instruction":"SINGLE. Если код 1 — завершить интервью.","ru":"Укажите Ваш пол.\n1. Мужской\n2. Женский","en":"Please indicate your gender.\n1. Male\n2. Female"},"S2":{"base":"Все респонденты","instruction":"NUMERIC. Допуск 25–55 лет. Вне диапазона — завершить интервью.","ru":"Укажите Ваш возраст.\n_____ лет\n\n1. 24 года и младше\n2. 25–30 лет\n3. 31–40 лет\n4. 41–50 лет\n5. 51–55 лет\n6. 56 лет и старше","en":"Please indicate your age.\n_____ years\n\n1. 24 years or younger\n2. 25–30 years\n3. 31–40 years\n4. 41–50 years\n5. 51–55 years\n6. 56 years or older"},"S3":{"base":"Все респонденты","instruction":"SINGLE. Контроль географии / квот.","ru":"В каком городе Вы проживаете?\n1. Алматы\n2. Астана\n3. Шымкент\n4. Талдыкорган\n5. Тараз\n6. Кызылорда\n7. Туркестан\n8. Актобе\n9. Актау\n10. Атырау\n11. Уральск\n12. Кокшетау\n13. Петропавловск\n14. Костанай\n15. Караганда\n16. Павлодар\n17. Усть-Каменогорск\n18. Семей","en":"Which city do you live in?\n1. Almaty\n2. Astana\n3. Shymkent\n4. Taldykorgan\n5. Taraz\n6. Kyzylorda\n7. Turkistan\n8. Aktobe\n9. Aktau\n10. Atyrau\n11. Oral\n12. Kokshetau\n13. Petropavl\n14. Kostanay\n15. Karaganda\n16. Pavlodar\n17. Oskemen\n18. Semey"},"S4":{"base":"Все респонденты","instruction":"SINGLE. Если код 1 — завершить интервью.","ru":"Как бы Вы оценили уровень дохода Вашей семьи?\n1. Не хватает денег на питание\n2. Хватает на питание, но покупка одежды вызывает трудности\n3. Хватает на текущие расходы, но покупка крупной бытовой техники затруднительна\n4. Хватает на крупную бытовую технику, но не на автомобиль\n5. Хватает практически на всё, кроме очень дорогих приобретений","en":"How would you describe your household income level?\n1. We do not have enough money for food\n2. We can afford food, but buying clothes is difficult\n3. We can cover current expenses, but buying major household appliances is difficult\n4. We can afford major household appliances, but not a car\n5. We can afford almost everything except very expensive purchases"},"S6":{"base":"Все респонденты","instruction":"MULTI. В текущей версии отмечено как возможный вопрос на удаление; подтвердить перед программированием.","ru":"Какие из следующих проблем с пищеварением возникали у Вас за последние 6 месяцев?\n1. Тяжесть после еды\n2. Вздутие\n3. Дискомфорт после переедания\n4. Несварение\n5. Газообразование\n6. Дискомфорт после жирной пищи\n7. Другое\n8. Ничего из перечисленного","en":"Which of the following digestive problems have you experienced in the past six months?\n1. Heaviness after eating\n2. Bloating\n3. Discomfort after overeating\n4. Indigestion\n5. Gas\n6. Discomfort after fatty food\n7. Other\n8. None of the above"},"S7":{"base":"Все респонденты","instruction":"MULTI, не более 4 ответов. Если код 1 не выбран — завершить интервью. Код 99 исключительный.","ru":"Какие из следующих групп лекарств Вы принимали лично за последние 6 месяцев?\n1. Ферментные препараты для улучшения пищеварения\n2. Слабительные препараты для облегчения запора\n3. Лекарства для улучшения функции печени\n4. Обезболивающие препараты\n99. Ничего из вышеперечисленного","en":"Which of the following groups of medicines have you personally used in the past six months?\n1. Digestive enzyme products\n2. Laxatives for constipation relief\n3. Medicines to support liver function\n4. Pain relievers\n99. None of the above"},"S8":{"base":"Все респонденты","instruction":"SINGLE. Purchase decision maker and primary shopper. Если код 2 или 3 — завершить интервью.","ru":"Вы сами покупали ферментные препараты для улучшения пищеварения за последние 6 месяцев?\n1. Всегда сама\n2. Иногда я, иногда другие члены семьи\n3. Сама не покупала","en":"Have you personally purchased digestive enzyme products in the past six months?\n1. Always myself\n2. Sometimes me, sometimes other family members\n3. I did not purchase them myself"},"S9":{"base":"Все респонденты","instruction":"MULTI. Квота: 50% пользователей Creon® / 50% непользователей.","ru":"Какие из следующих ферментных препаратов Вы принимали?\n1. Creon®\n2. Микразим\n3. Фестал\n4. Мезим\n5. Панкреатин\n6. Панкреазим\n7. Другие","en":"Which of the following digestive enzyme products have you used?\n1. Creon®\n2. Micrazim\n3. Festal\n4. Mezim\n5. Pancreatin\n6. Pancreazim\n7. Other products"},"S10":{"base":"S9≠1","instruction":"SINGLE. Если код 2 — завершить интервью.","ru":"Если Вашего препарата не будет в продаже, рассмотрите ли Вы покупку Creon® при условии той же цены?\n1. Да\n2. Нет","en":"If your usual product were unavailable, would you consider buying Creon® at the same price?\n1. Yes\n2. No"},"Q1":{"base":"Все респонденты","instruction":"SINGLE.","ru":"Как часто Вы обычно принимаете ферментные препараты для улучшения пищеварения?\n1. Несколько раз в неделю\n2. Примерно раз в неделю\n3. 2–3 раза в месяц\n4. Примерно раз в месяц\n5. Реже одного раза в месяц","en":"How often do you usually take digestive enzyme products?\n1. Several times a week\n2. About once a week\n3. 2–3 times a month\n4. About once a month\n5. Less often than once a month"},"Q2":{"base":"Все респонденты","instruction":"MULTI. Ротировать коды 1–7; код 8 фиксировать внизу.","ru":"В каких ситуациях Вы обычно принимаете ферментные препараты?\n1. При тяжести или ощущении переполненности после еды\n2. При дискомфорте после еды\n3. При вздутии\n4. После переедания\n5. После жирной / тяжелой пищи\n6. Во время или после застолий, праздников\n7. По рекомендации врача в определенных ситуациях / курсом\n8. Другое, укажите ______","en":"In which situations do you usually take digestive enzyme products?\n1. When feeling heaviness or fullness after eating\n2. When experiencing discomfort after eating\n3. When bloated\n4. After overeating\n5. After fatty / heavy food\n6. During or after celebrations and large meals\n7. On a doctor's recommendation in specific situations / as a course\n8. Other, please specify ______"},"Q3":{"base":"Все респонденты","instruction":"GRID, один ответ в каждой строке. Шкала 1–7.","ru":"Что для Вас наиболее важно при выборе ферментного препарата?\n1 = совершенно не важно; 7 = чрезвычайно важно\n1. Эффективность\n2. Безопасность\n3. Доверие к бренду\n4. Рекомендация врача\n5. Рекомендация фармацевта\n6. Собственный положительный опыт\n7. Понятность назначения препарата\n8. Удобство применения\n9. Длительный эффект\n10. Цена\n11. Понятная и информативная упаковка\n12. Скорость действия","en":"What is most important to you when choosing a digestive enzyme product?\n1 = not at all important; 7 = extremely important\n1. Effectiveness\n2. Safety\n3. Trust in the brand\n4. Doctor recommendation\n5. Pharmacist recommendation\n6. Own positive experience\n7. Clarity of the product's intended use\n8. Ease of use\n9. Long-lasting effect\n10. Price\n11. Clear and informative packaging\n12. Speed of action"},"ET0":{"base":"Все респонденты","instruction":"SINGLE. Автоматически не исключать. При невозможности корректной калибровки зафиксировать технический статус eye-tracking; анкетную часть продолжить.","ru":"Используете ли Вы сейчас средства коррекции зрения?\n1. Нет\n2. Очки\n3. Контактные линзы","en":"Are you currently using any vision correction?\n1. No\n2. Glasses\n3. Contact lenses"},"ET_TEST1_INTRO":{"base":"Все респонденты","instruction":"Показать конкурентную полку 8–10 секунд. Ротировать позиции A/B. Во время экспозиции вопросов не показывать. Eye-tracking автоматически фиксирует time to first fixation, reach, total fixation duration, fixation count, return visits.","ru":"Сейчас Вы увидите изображение аптечной полки с несколькими препаратами для пищеварения. Пожалуйста, посмотрите на нее так, как если бы Вы находились в аптеке и выбирали подходящий препарат. Специально искать какой-либо бренд не нужно — просто внимательно рассмотрите полку.","en":"You will now see an image of a pharmacy shelf containing several digestive products. Please look at it as if you were in a pharmacy choosing a suitable product. You do not need to look for any particular brand; simply examine the shelf carefully."},"ET1.1":{"base":"После показа конкурентной полки","instruction":"MULTI. Полку повторно не показывать.","ru":"Какие из препаратов на полке Вы запомнили?\n1. Creon®\n2. Конкурент 1\n3. Конкурент 2\n4. Конкурент 3\n5. Другой препарат\n6. Не помню ни одного","en":"Which products on the shelf do you remember?\n1. Creon®\n2. Competitor 1\n3. Competitor 2\n4. Competitor 3\n5. Another product\n6. I do not remember any"},"ET1.2":{"base":"После показа конкурентной полки","instruction":"SINGLE. Полку повторно не показывать.","ru":"Какой препарат Вы заметили первым?\n1. Creon®\n2. Конкурент 1\n3. Конкурент 2\n4. Конкурент 3\n5. Другой препарат\n6. Не помню","en":"Which product did you notice first?\n1. Creon®\n2. Competitor 1\n3. Competitor 2\n4. Competitor 3\n5. Another product\n6. I do not remember"},"ET1.3":{"base":"После показа конкурентной полки","instruction":"SINGLE. Использовать тот же список, что в ET1.2.","ru":"Какой препарат на этой полке сильнее всего привлек Ваше внимание?","en":"Which product on this shelf attracted your attention the most?"},"ET1.4":{"base":"После показа конкурентной полки","instruction":"SINGLE. Использовать тот же список, что в ET1.2.","ru":"Какой препарат Вы бы в первую очередь рассмотрели для выбора?","en":"Which product would you consider first?"},"ET2_INTRO":{"base":"Перед каждым концептом A/B","instruction":"Показать концепт 10 секунд. Порядок A/B рандомизировать. Вопросы одновременно с упаковкой не выводить.","ru":"Сейчас Вы увидите упаковку препарата. Пожалуйста, внимательно рассмотрите ее так, как Вы обычно рассматриваете упаковку препарата перед покупкой или применением. После просмотра мы зададим несколько вопросов.","en":"You will now see a medicine pack. Please examine it carefully as you normally would before purchasing or using a medicine. After viewing it, we will ask you a few questions."},"ET2.1":{"base":"После показа каждого концепта","instruction":"SINGLE.","ru":"Что Вы заметили на упаковке в первую очередь?\n1. Название Creon®\n2. Дозировку 10 000\n3. Изображение вихря / минимикросфер\n4. Изображение желудка / кишечника\n5. Фразу «Мультиферменты для улучшения пищеварения»\n6. Фразу «Быстро растворяется в желудке»\n7. Информацию о назначении препарата\n8. Количество капсул / формат упаковки\n9. Логотип производителя\n10. Другое\n11. Не могу вспомнить","en":"What did you notice first on the pack?\n1. The Creon® name\n2. The 10,000 dosage\n3. The swirl / minimicrospheres image\n4. The stomach / intestine image\n5. The phrase “Multi-enzymes for improved digestion”\n6. The phrase “Dissolves quickly in the stomach”\n7. Information about the product's intended use\n8. Number of capsules / pack format\n9. Manufacturer logo\n10. Other\n11. Cannot remember"},"ET2.2":{"base":"После показа каждого концепта","instruction":"MULTI. Использовать тот же список, что в ET2.1.","ru":"Какие элементы упаковки Вы запомнили?","en":"Which elements of the pack do you remember?"},"ET2.3":{"base":"После показа каждого концепта","instruction":"SINGLE. Использовать тот же список, что в ET2.1.","ru":"Что на упаковке было легче всего заметить?","en":"What was easiest to notice on the pack?"},"ET2.4":{"base":"После показа каждого концепта","instruction":"MULTI. Использовать коды 1–9 из списка ET2.1.","ru":"Что на упаковке было трудно заметить или прочитать?","en":"What was difficult to notice or read on the pack?"},"P1":{"base":"Loop A/B","instruction":"SINGLE, шкала 1–7. Во время оценки продолжать показывать соответствующую упаковку.","ru":"Насколько Вам в целом нравится дизайн этой упаковки?\n1 = совершенно не нравится; 7 = очень нравится","en":"Overall, how much do you like the design of this pack?\n1 = do not like it at all; 7 = like it very much"},"P2":{"base":"Loop A/B","instruction":"GRID, один ответ в каждой строке. Шкала 1–7. Ротировать утверждения внутри тематических групп; порядок групп сохранять.","ru":"Насколько Вы согласны или не согласны с утверждениями об этой упаковке?\n1 = совершенно не согласна; 7 = полностью согласна\n1. Дизайн упаковки выглядит современным.\n2. Эта упаковка соответствует моим ожиданиям от препарата Creon®.\n3. Эта упаковка выглядит как упаковка лекарственного препарата, а не диетической добавки.\n4. Эта упаковка дает ясную и понятную информацию.\n5. Creon® в этой упаковке воспринимается как эксперт в категории препаратов для пищеварения.\n6. Эта упаковка ясно объясняет, для чего предназначен препарат и какие у него преимущества.\n7. Эта упаковка отличается от других препаратов для пищеварения.\n8. Эту упаковку будет легко найти среди других препаратов на аптечной полке.\n9. Цвет и дизайн этой упаковки хорошо выделяются среди других упаковок.\n10. Бренд Creon® легко узнать по этой упаковке.\n11. Из этой упаковки понятно, что в составе Creon® несколько видов ферментов.\n12. Название препарата легко прочитать.\n13. Эта упаковка вызывает доверие.\n14. Эта упаковка создает ощущение высокого качества препарата.\n15. Эта упаковка говорит о длительном эффекте препарата.\n16. Препарат в этой упаковке выглядит безопасным.\n17. Эта упаковка соответствует репутации бренда Creon®.\n18. Эта упаковка вызывает уверенность в эффективности препарата.\n19. Эта упаковка создает ощущение заботы о пациенте.\n20. Эта упаковка говорит о быстром действии препарата.\n21. В этой упаковке препарат выглядит инновационным.\n22. В этой упаковке препарат выглядит премиальным.","en":"How much do you agree or disagree with the following statements about this pack?\n1 = completely disagree; 7 = completely agree\n1. The pack design looks modern.\n2. This pack meets my expectations of Creon®.\n3. This looks like the packaging of a medicine rather than a dietary supplement.\n4. This pack provides clear and understandable information.\n5. Creon® in this pack is perceived as an expert in the digestive products category.\n6. This pack clearly explains what the product is for and what benefits it offers.\n7. This pack is different from other digestive products.\n8. This pack would be easy to find among other products on a pharmacy shelf.\n9. The colour and design of this pack stand out well among other packs.\n10. The Creon® brand is easy to recognise from this pack.\n11. This pack makes it clear that Creon® contains several types of enzymes.\n12. The product name is easy to read.\n13. This pack inspires trust.\n14. This pack creates an impression of a high-quality product.\n15. This pack communicates a long-lasting effect.\n16. The product looks safe in this pack.\n17. This pack is consistent with the reputation of the Creon® brand.\n18. This pack gives confidence in the product's effectiveness.\n19. This pack creates a sense of care for the patient.\n20. This pack communicates fast action.\n21. The product looks innovative in this pack.\n22. The product looks premium in this pack."},"P3":{"base":"Loop A/B","instruction":"GRID, один ответ в каждой строке. Шкала 1–7.","ru":"Насколько легко по этой упаковке понять следующую информацию?\n1 = совершенно непонятно; 7 = совершенно понятно\n1. Для чего предназначен препарат\n2. В каких ситуациях он может применяться\n3. Какая у препарата дозировка\n4. Какие основные преимущества имеет препарат\n5. Ключевую информацию на упаковке в целом","en":"How easy is it to understand the following information from this pack?\n1 = completely unclear; 7 = completely clear\n1. What the product is intended for\n2. In which situations it can be used\n3. The product dosage\n4. The product's main benefits\n5. The key information on the pack overall"},"P4":{"base":"Loop A/B","instruction":"SINGLE, шкала 1–7.","ru":"Насколько легко Вы сможете отличить эту дозировку Creon® от других дозировок препарата по оформлению упаковки?\n1 = очень сложно отличить; 7 = очень легко отличить","en":"How easy would it be to distinguish this Creon® dosage from other dosages based on the pack design?\n1 = very difficult; 7 = very easy"},"P5a":{"base":"Loop A/B","instruction":"SINGLE.","ru":"Обратили ли Вы внимание на изображение вихря с минимикросферами на упаковке?\n1. Да\n2. Нет / не уверена","en":"Did you notice the swirl with minimicrospheres on the pack?\n1. Yes\n2. No / not sure"},"P5b":{"base":"Loop A/B","instruction":"MULTI. Ротировать смысловые коды; «элемент дизайна», «непонятно» и «другое» фиксировать внизу.","ru":"Как Вы воспринимаете это изображение?\n1. Оно помогает понять принцип действия препарата\n2. Оно показывает особую технологию / форму препарата\n3. Оно создает ощущение эффективного действия препарата\n4. Оно создает ощущение быстрого действия препарата\n5. Оно передает идею взаимодействия / смешивания препарата с пищей\n6. Оно делает препарат более современным\n7. Оно делает препарат более инновационным\n8. Оно усиливает ощущение экспертности препарата\n9. Оно просто является элементом дизайна и не несет для меня конкретного смысла\n10. Мне непонятно, что означает это изображение\n11. Другое, укажите ______","en":"How do you perceive this image?\n1. It helps explain how the product works\n2. It represents a special technology / product form\n3. It creates an impression of effective action\n4. It creates an impression of fast action\n5. It conveys the idea of interaction / mixing with food\n6. It makes the product look more modern\n7. It makes the product look more innovative\n8. It strengthens the product's expert image\n9. It is simply a design element and has no specific meaning for me\n10. I do not understand what this image means\n11. Other, please specify ______"},"P5c":{"base":"Loop A/B","instruction":"SINGLE, шкала 1–7.","ru":"Насколько хорошо изображение вихря с минимикросферами помогает передать преимущества Creon®?\n1 = совершенно не помогает; 7 = очень хорошо помогает","en":"How well does the swirl with minimicrospheres communicate the benefits of Creon®?\n1 = does not help at all; 7 = helps very well"},"P6a":{"base":"Loop A/B","instruction":"MULTI. Подставить реальные claims каждого концепта. Код 3 исключительный.","ru":"Какие из следующих сообщений на упаковке Вы заметили?\n1. «Мультиферменты для улучшения пищеварения»\n2. «Быстро растворяется в желудке»\n3. Не заметила ни одного","en":"Which of the following messages did you notice on the pack?\n1. “Multi-enzymes for improved digestion”\n2. “Dissolves quickly in the stomach”\n3. Did not notice any"},"P6b":{"base":"Loop A/B; по каждому присутствующему claim","instruction":"GRID / LOOP, шкала 1–7. 1 = минимальная оценка; 7 = максимальная оценка.","ru":"Насколько это сообщение Вам понятно?","en":"How clear is this message to you?"},"P6c":{"base":"Loop A/B; по каждому присутствующему claim","instruction":"GRID / LOOP, шкала 1–7. 1 = минимальная оценка; 7 = максимальная оценка.","ru":"Насколько это сообщение вызывает доверие?","en":"How trustworthy is this message?"},"P6d":{"base":"Loop A/B; по каждому присутствующему claim","instruction":"GRID / LOOP, шкала 1–7. 1 = минимальная оценка; 7 = максимальная оценка.","ru":"Насколько оно важно / актуально лично для Вас при выборе ферментного препарата?","en":"How important / relevant is this message to you when choosing a digestive enzyme product?"},"P6e":{"base":"Loop A/B; по каждому присутствующему claim","instruction":"GRID / LOOP, шкала 1–7. 1 = минимальная оценка; 7 = максимальная оценка.","ru":"Насколько это сообщение усиливает желание выбрать Creon®?","en":"How much does this message increase your desire to choose Creon®?"},"P7":{"base":"Loop A/B","instruction":"GRID, один ответ в каждой строке. Шкала 1–7.","ru":"Насколько Вам нравятся следующие элементы этой упаковки?\n1 = совершенно не нравится; 7 = очень нравится\n1. Цветовое решение упаковки\n2. Написание и оформление названия Creon®\n3. Размер и читаемость названия Creon®\n4. Обозначение дозировки\n5. Изображение вихря с минимикросферами\n6. Расположение информации на упаковке\n7. Общая композиция дизайна\n8. Дизайн упаковки в целом","en":"How much do you like the following elements of this pack?\n1 = do not like at all; 7 = like very much\n1. Pack colour scheme\n2. Typography and presentation of the Creon® name\n3. Size and readability of the Creon® name\n4. Dosage presentation\n5. Swirl with minimicrospheres\n6. Layout of information on the pack\n7. Overall design composition\n8. Overall pack design"},"P8a":{"base":"Loop A/B","instruction":"SINGLE, шкала 1–5.","ru":"Если бы при необходимости Вы увидели Creon® в такой упаковке в аптеке, насколько вероятно, что Вы выбрали бы его?\n1. Точно не выбрала бы\n2. Скорее не выбрала бы\n3. Возможно, выбрала бы, возможно нет\n4. Скорее выбрала бы\n5. Точно выбрала бы","en":"If you needed such a product and saw Creon® in this pack in a pharmacy, how likely would you be to choose it?\n1. Definitely would not choose\n2. Probably would not choose\n3. Might or might not choose\n4. Probably would choose\n5. Definitely would choose"},"P8b":{"base":"Loop A/B","instruction":"SINGLE, шкала 1–7.","ru":"Насколько Вам хотелось бы использовать Creon® именно в такой упаковке?\n1 = совсем не хотелось бы; 7 = очень хотелось бы","en":"How much would you like to use Creon® in this pack?\n1 = would not like at all; 7 = would like very much"},"P8c":{"base":"Loop A/B","instruction":"SINGLE, шкала 1–7.","ru":"Насколько Вы были бы готовы рекомендовать Creon® в такой упаковке близкому человеку, если ему подходит такой препарат?\n1 = совершенно не готова; 7 = полностью готова","en":"How willing would you be to recommend Creon® in this pack to someone close to you if this type of product were suitable for them?\n1 = not at all willing; 7 = completely willing"},"P9":{"base":"Loop A/B","instruction":"MULTI. Последний код исключительный.","ru":"Есть ли что-либо в этой упаковке, что Вас смущает?\n1. Выглядит слишком серьезно для лекарственного препарата\n2. Выглядит недостаточно серьезно для лекарственного препарата\n3. Напоминает диетическую добавку\n4. Недостаточно узнаваема как Creon®\n5. Непонятно назначение препарата\n6. Недостаточно заметна дозировка\n7. Слишком мало информации\n8. Слишком много информации\n9. Дизайн выглядит слишком сложным / перегруженным\n10. Дизайн выглядит слишком простым\n11. Другое, укажите ______\n12. Ничего не смущает","en":"Is there anything about this pack that concerns you?\n1. Looks too serious for a medicine\n2. Does not look serious enough for a medicine\n3. Looks like a dietary supplement\n4. Not recognisable enough as Creon®\n5. The intended use is unclear\n6. The dosage is not prominent enough\n7. There is too little information\n8. There is too much information\n9. The design looks too complex / cluttered\n10. The design looks too simple\n11. Other, please specify ______\n12. Nothing concerns me"},"C1":{"base":"После оценки A и B; показать также текущую упаковку, если согласовано","instruction":"SINGLE.","ru":"Какая из упаковок Вам в целом нравится больше?\n1. Упаковка A\n2. Упаковка B\n3. Текущая упаковка Creon®\n4. Нравятся одинаково\n5. Не нравится ни одна","en":"Which pack do you like most overall?\n1. Pack A\n2. Pack B\n3. Current Creon® pack\n4. Like them equally\n5. Do not like any"},"C2":{"base":"После оценки A и B","instruction":"GRID. Для каждой строки: A / B / текущая упаковка / одинаково / ни одна.","ru":"Какая упаковка лучше соответствует каждому описанию?\n1. Лучше соответствует бренду Creon®\n2. Выглядит более профессиональной и лекарственной\n3. Вызывает больше доверия\n4. Больше говорит об эффективности препарата\n5. Лучше объясняет назначение препарата\n6. Больше говорит о скорости действия препарата\n7. Лучше выделяется среди конкурентов\n8. Лучше передает преимущества Creon®\n9. Выглядит более современной\n10. Выглядит более инновационной\n11. Вызывает большее желание выбрать препарат","en":"Which pack best fits each description?\n1. Better fits the Creon® brand\n2. Looks more professional and medicinal\n3. Inspires more trust\n4. Communicates product effectiveness better\n5. Explains the intended use better\n6. Communicates speed of action better\n7. Stands out better among competitors\n8. Communicates the benefits of Creon® better\n9. Looks more modern\n10. Looks more innovative\n11. Creates a stronger desire to choose the product"},"C3":{"base":"После показа текущей упаковки","instruction":"GRID, оценить A и B по шкале 1–7.","ru":"Насколько каждая новая упаковка сохраняет узнаваемость привычного Creon®?\n1 = совершенно не сохраняет; 7 = полностью сохраняет","en":"To what extent does each new pack preserve the recognisability of the familiar Creon® pack?\n1 = does not preserve it at all; 7 = preserves it completely"},"C4":{"base":"После показа текущей упаковки","instruction":"SINGLE.","ru":"Какой вариант упаковки Вы в целом предпочитаете?\n1. Текущая упаковка Creon®\n2. Новая упаковка A\n3. Новая упаковка B\n4. Нет предпочтения","en":"Which pack option do you prefer overall?\n1. Current Creon® pack\n2. New pack A\n3. New pack B\n4. No preference"},"C5":{"base":"После показа текущей упаковки","instruction":"SINGLE.","ru":"Какая упаковка лучше всего сочетает современный дизайн и узнаваемость Creon®?\n1. Текущая упаковка\n2. Упаковка A\n3. Упаковка B\n4. Нет различий","en":"Which pack best combines modern design with Creon® recognisability?\n1. Current pack\n2. Pack A\n3. Pack B\n4. No difference"},"C6":{"base":"После показа текущей упаковки","instruction":"SINGLE.","ru":"Какую упаковку Creon® Вы предпочли бы увидеть в аптеке в будущем?\n1. Текущую упаковку\n2. Упаковку A\n3. Упаковку B\n4. Нет предпочтения","en":"Which Creon® pack would you prefer to see in pharmacies in the future?\n1. Current pack\n2. Pack A\n3. Pack B\n4. No preference"},"C7":{"base":"Все респонденты","instruction":"MULTI, не более 3 ответов.","ru":"Какие элементы особенно важно сохранить в финальном варианте упаковки Creon®?\n1. Цветовая гамма\n2. Хорошо заметное название Creon®\n3. Шрифт / оформление названия\n4. Четко обозначенная дозировка\n5. Вихрь с минимикросферами\n6. Основное сообщение / claim\n7. Структура и расположение информации\n8. Общий профессиональный / медицинский вид\n9. Другое, укажите ______","en":"Which elements are particularly important to retain in the final Creon® pack?\n1. Colour scheme\n2. Clearly visible Creon® name\n3. Font / presentation of the name\n4. Clearly displayed dosage\n5. Swirl with minimicrospheres\n6. Main message / claim\n7. Structure and layout of information\n8. Overall professional / medical appearance\n9. Other, please specify ______"},"C8":{"base":"Все респонденты","instruction":"OPEN.","ru":"Почему Вы предпочли именно этот вариант упаковки?","en":"Why did you prefer this particular pack option?"}};

const UI = {
  en: {
    next: "Next", back: "Back", continue: "Continue", question: "Question", of: "of",
    section: "Consumer study", required: "Please answer this question.",
    max: (n) => `Select no more than ${n} answers.`, other: "Please specify",
    placeholder: "Type your answer here…", age: "Age in years", screenTitle: "Thank you",
    saved: "Your answers have been recorded.",
    screened: "Based on the study criteria, the interview cannot continue.",
    network: "We could not save your answers. Please check your connection and try again.",
    retry: "Try again", reference: "Reference No.", visual: "Study visual",
    missing: "The study image is not yet available on this server.",
    seconds: (n) => `Please examine the visual for ${n} seconds.`,
    packA: "Pack A", packB: "Pack B", current: "Current pack", scaleLow: "Low", scaleHigh: "High",
    cameraStarting: "Preparing the eye-tracking camera…",
    cameraReadyTitle: "Camera check",
    cameraReadyBody: "Keep your face centered in the camera frame and remove sunglasses or anything that hides your eyes.",
    startCalibration: "Start calibration",
    calibrationTitle: "Eye-tracking calibration",
    calibrationBody: "Look directly at each point and click it five times. Keep your head still and move only your eyes.",
    calibrationProgress: (done, total) => `${done} of ${total} calibration clicks completed`,
    calibrationError: "The camera or eye-tracking model could not be started. Allow camera access and try again.",
    retryCalibration: "Try camera again",
    trackingPreparing: "Preparing eye tracking for this visual…",
    faceChecking: "Looking for your face…",
    faceReady: "Face detected. You can start the calibration.",
    faceMissing: "No face detected. Center your face in the camera and keep it visible.",
    faceMissingTitle: "Please return to the camera",
    faceMissingBody: "Your face is no longer visible. Keep your face centered before continuing the study.",
    eyewearChecking: "Checking that both eyes are clearly visible…",
    eyewearBlocked: "Your eyes are obscured. Remove your sunglasses to continue.",
    eyewearWarningTitle: "Please remove your sunglasses",
    eyewearWarningBody: "Eye tracking requires both eyes to remain clearly visible.",
    desktopOnlyTitle: "Desktop browser required",
    desktopOnlyBody: "This survey uses camera-based eye tracking and can only be completed on a desktop or laptop computer. Please open this link in a desktop browser.",
    guideTitle: "Before you start",
    cameraGuideTitle: "Center your face",
    cameraGuideBody: "Sit in front of the camera in a well-lit place and keep your whole face inside the frame.",
    visibilityGuideTitle: "Keep your eyes visible",
    visibilityGuideBody: "Remove sunglasses and keep both eyes open and clearly visible throughout the study.",
    calibrationGuideTitle: "Follow the targets",
    calibrationGuideBody: "Look directly at each target and click it five times without moving your head.",
    reminderStill: "Keep your head still",
    reminderLook: "Look at the target",
    reminderClick: "Click 5 times",
    recordingNotice: "Camera video is recorded only during the eye-tracking visuals (questions 17 and 22) and uploaded with your survey response.",
  },
  ru: {
    next: "Далее", back: "Назад", continue: "Продолжить", question: "Вопрос", of: "из",
    section: "Исследование потребителей", required: "Пожалуйста, ответьте на вопрос.",
    max: (n) => `Выберите не более ${n} вариантов.`, other: "Укажите, пожалуйста",
    placeholder: "Введите Ваш ответ…", age: "Возраст, лет", screenTitle: "Благодарим Вас",
    saved: "Ваши ответы сохранены.",
    screened: "Согласно критериям исследования интервью не может быть продолжено.",
    network: "Не удалось сохранить ответы. Проверьте подключение и повторите попытку.",
    retry: "Повторить", reference: "Номер ссылки", visual: "Материал исследования",
    missing: "Изображение исследования пока недоступно на сервере.",
    seconds: (n) => `Пожалуйста, рассмотрите изображение в течение ${n} секунд.`,
    packA: "Упаковка A", packB: "Упаковка B", current: "Текущая упаковка",
    scaleLow: "Низкая", scaleHigh: "Высокая",
    cameraStarting: "Подготовка камеры для отслеживания взгляда…",
    cameraReadyTitle: "Проверка камеры",
    cameraReadyBody: "Расположите лицо по центру кадра и снимите солнцезащитные очки или всё, что закрывает глаза.",
    startCalibration: "Начать калибровку",
    calibrationTitle: "Калибровка отслеживания взгляда",
    calibrationBody: "Смотрите прямо на каждую точку и нажмите на нее пять раз. Держите голову неподвижно и двигайте только глазами.",
    calibrationProgress: (done, total) => `Выполнено ${done} из ${total} нажатий`,
    calibrationError: "Не удалось запустить камеру или модель отслеживания взгляда. Разрешите доступ к камере и повторите попытку.",
    retryCalibration: "Повторить запуск камеры",
    trackingPreparing: "Подготовка отслеживания взгляда для изображения…",
    faceChecking: "Поиск лица в кадре…",
    faceReady: "Лицо обнаружено. Можно начинать калибровку.",
    faceMissing: "Лицо не обнаружено. Расположите лицо по центру камеры и оставайтесь в кадре.",
    faceMissingTitle: "Пожалуйста, вернитесь к камере",
    faceMissingBody: "Ваше лицо больше не видно. Перед продолжением исследования расположитесь по центру кадра.",
    eyewearChecking: "Проверяем, что оба глаза хорошо видны…",
    eyewearBlocked: "Глаза закрыты. Снимите солнцезащитные очки, чтобы продолжить.",
    eyewearWarningTitle: "Пожалуйста, снимите солнцезащитные очки",
    eyewearWarningBody: "Для отслеживания взгляда оба глаза должны быть хорошо видны.",
    desktopOnlyTitle: "Требуется компьютер",
    desktopOnlyBody: "В этом опросе используется отслеживание взгляда с помощью камеры, поэтому его можно пройти только на настольном компьютере или ноутбуке. Откройте эту ссылку в браузере на компьютере.",
    guideTitle: "Перед началом",
    cameraGuideTitle: "Расположите лицо по центру",
    cameraGuideBody: "Сядьте перед камерой в хорошо освещенном месте и держите лицо полностью внутри рамки.",
    visibilityGuideTitle: "Глаза должны быть видны",
    visibilityGuideBody: "Снимите солнцезащитные очки и держите оба глаза открытыми и хорошо видимыми на протяжении исследования.",
    calibrationGuideTitle: "Следуйте за точками",
    calibrationGuideBody: "Смотрите прямо на каждую точку и нажмите на нее пять раз, не двигая головой.",
    reminderStill: "Не двигайте головой",
    reminderLook: "Смотрите на точку",
    reminderClick: "Нажмите 5 раз",
    recordingNotice: "Видео с камеры записывается только во время материалов для отслеживания взгляда (вопросы 17 и 22) и загружается вместе с ответами.",
  },
};

const CALIBRATION_CLICKS_PER_POINT = 5;
const CALIBRATION_POINTS = [
  { x: 10, y: 27 }, { x: 50, y: 27 }, { x: 90, y: 27 },
  { x: 10, y: 55 }, { x: 50, y: 55 }, { x: 90, y: 55 },
  { x: 10, y: 85 }, { x: 50, y: 85 }, { x: 90, y: 85 },
];
const TRACKED_QUESTION_NUMBERS = [17, 22];
const MAX_GAZE_SAMPLES_PER_RECORDING = 1000;
const FACE_CONFIRMATION_MS = 1200;
const FACE_MISSING_WARNING_MS = 1800;
const EYEWEAR_CHECK_INTERVAL_MS = 140;
const EYEWEAR_DECISION_SAMPLE_COUNT = 8;

function detectMobileBrowser() {
  if (typeof navigator === "undefined") return false;
  if (navigator.userAgentData?.mobile === true) return true;

  const userAgent = navigator.userAgent || "";
  const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile|Silk/i.test(userAgent);
  const iPadDesktopMode = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
  return mobileUserAgent || iPadDesktopMode;
}

function getCameraRecordingFormat() {
  if (typeof MediaRecorder === "undefined") return null;
  const candidates = [
    { mimeType: "video/webm;codecs=vp8", extension: "webm" },
    { mimeType: "video/webm", extension: "webm" },
    { mimeType: "video/mp4;codecs=avc1.42E01E", extension: "mp4" },
    { mimeType: "video/mp4", extension: "mp4" },
  ];
  return candidates.find(({ mimeType }) => MediaRecorder.isTypeSupported(mimeType)) || { mimeType: "", extension: "webm" };
}

function sampleLuminance(canvas, centerX, centerY, width, height) {
  const context = canvas?.getContext?.("2d", { willReadFrequently: true });
  if (!context || !canvas.width || !canvas.height) return null;

  const left = Math.max(0, Math.floor(centerX - width / 2));
  const top = Math.max(0, Math.floor(centerY - height / 2));
  const right = Math.min(canvas.width, Math.ceil(centerX + width / 2));
  const bottom = Math.min(canvas.height, Math.ceil(centerY + height / 2));
  if (right - left < 4 || bottom - top < 4) return null;

  const pixels = context.getImageData(left, top, right - left, bottom - top).data;
  let sum = 0;
  let squaredSum = 0;
  let count = 0;
  for (let index = 0; index < pixels.length; index += 16) {
    const luminance = 0.2126 * pixels[index] + 0.7152 * pixels[index + 1] + 0.0722 * pixels[index + 2];
    sum += luminance;
    squaredSum += luminance * luminance;
    count += 1;
  }

  if (!count) return null;
  const mean = sum / count;
  return { mean, deviation: Math.sqrt(Math.max(0, squaredSum / count - mean * mean)) };
}

function detectDarkEyewear(tracker) {
  try {
    const positions = tracker?.getTracker?.()?.getPositions?.();
    const canvas = tracker?.getVideoElementCanvas?.();
    if (!Array.isArray(positions) || positions.length < 455 || !canvas) return null;

    const faceWidth = Math.abs(positions[454][0] - positions[234][0]);
    const faceHeight = Math.abs(positions[152][1] - positions[10][1]);
    if (faceWidth < 40 || faceHeight < 50) return null;

    const eyeDefinitions = [
      { outer: 33, inner: 133, upper: 159, lower: 145 },
      { outer: 263, inner: 362, upper: 386, lower: 374 },
    ];

    const comparisons = eyeDefinitions.map((eye) => {
      const outer = positions[eye.outer];
      const inner = positions[eye.inner];
      const upper = positions[eye.upper];
      const lower = positions[eye.lower];
      const centerX = (outer[0] + inner[0]) / 2;
      const centerY = (upper[1] + lower[1]) / 2;
      const eyeWidth = Math.max(12, Math.abs(outer[0] - inner[0]));
      const eyeHeight = Math.max(Math.abs(upper[1] - lower[1]) * 2.6, eyeWidth * 0.34);
      const eyeRegion = sampleLuminance(canvas, centerX, centerY, eyeWidth * 1.08, eyeHeight);
      const cheekRegion = sampleLuminance(
        canvas,
        centerX,
        centerY + faceHeight * 0.2,
        eyeWidth * 0.82,
        faceHeight * 0.075,
      );
      if (!eyeRegion || !cheekRegion || cheekRegion.mean < 12) return null;

      return {
        luminanceRatio: eyeRegion.mean / cheekRegion.mean,
        textureRatio: eyeRegion.deviation / Math.max(cheekRegion.deviation, 1),
      };
    });

    if (comparisons.some((comparison) => !comparison)) return null;
    const bothEyesAreDark = comparisons.every((comparison) => comparison.luminanceRatio < 0.68);
    const averageRatio = comparisons.reduce((sum, comparison) => sum + comparison.luminanceRatio, 0) / comparisons.length;
    const averageTextureRatio = comparisons.reduce((sum, comparison) => sum + comparison.textureRatio, 0) / comparisons.length;
    return bothEyesAreDark && averageRatio < 0.62 && averageTextureRatio < 1.45;
  } catch (eyewearDetectionError) {
    return null;
  }
}

const SURVEY_CSS = `
.creon-survey{--bg:#f4f7fb;--card:#fff;--ink:#152033;--muted:#667085;--line:#d7deea;--brand:#3157c8;--brand2:#203f9d;--soft:#eef3ff;--danger:#b42318;--shadow:0 22px 60px rgba(36,56,99,.14);--radius:22px;box-sizing:border-box;min-height:100vh;background:radial-gradient(circle at 10% 0,rgba(49,87,200,.13),transparent 36%),var(--bg);color:var(--ink);font:clamp(14px,1.2vw,15px)/1.5 Inter,ui-sans-serif,system-ui,-apple-system,"Segoe UI",sans-serif;padding:clamp(12px,2.5vw,22px)}
.creon-survey *{box-sizing:border-box}.creon-survey button,.creon-survey input,.creon-survey textarea{font:inherit}.creon-shell{width:min(920px,100%);margin:0 auto}.creon-topbar{display:flex;align-items:center;justify-content:flex-end;gap:18px;margin:0 0 14px}.creon-lang{display:flex;border:1px solid var(--line);border-radius:999px;padding:3px;background:var(--card)}.creon-lang button{border:0;background:transparent;color:var(--muted);padding:7px 12px;border-radius:999px;cursor:pointer}.creon-lang button.active{background:var(--brand);color:#fff}
.creon-card{background:var(--card);border:1px solid var(--line);border-radius:var(--radius);box-shadow:var(--shadow);padding:clamp(18px,3vw,32px)}.creon-eyebrow{display:flex;align-items:center;justify-content:space-between;gap:12px;color:var(--muted);font-size:clamp(11px,1vw,13px);margin-bottom:12px}.creon-code{font-weight:700;color:var(--brand)}.creon-question{font-size:clamp(19px,2.2vw,26px);line-height:1.3;margin:0 0 16px;white-space:pre-line}.creon-alert{border:1px solid color-mix(in srgb,var(--danger) 45%,var(--line));background:color-mix(in srgb,var(--danger) 9%,var(--card));color:var(--danger);padding:11px 13px;border-radius:12px;margin-bottom:16px}
.creon-options{display:grid;gap:10px}.creon-opt{display:flex;align-items:flex-start;gap:11px;padding:13px 14px;border:1px solid var(--line);border-radius:14px;cursor:pointer;background:color-mix(in srgb,var(--card) 96%,var(--soft));transition:.16s}.creon-opt:hover{border-color:var(--brand);transform:translateY(-1px)}.creon-opt:has(input:checked){border-color:var(--brand);background:var(--soft)}.creon-opt input{margin-top:4px;accent-color:var(--brand)}.creon-opt-code{min-width:22px;color:var(--muted);font-size:13px;padding-top:1px}
.creon-field{width:100%;border:1px solid var(--line);border-radius:14px;background:var(--card);color:var(--ink);padding:14px 15px;outline:none}.creon-field:focus{border-color:var(--brand);box-shadow:0 0 0 4px color-mix(in srgb,var(--brand) 16%,transparent)}textarea.creon-field{min-height:130px;resize:vertical}.creon-other{margin-top:12px}.creon-counter{text-align:right;color:var(--muted);font-size:12px;margin-top:5px}
.creon-matrix-wrap{overflow:auto;border:1px solid var(--line);border-radius:15px}.creon-matrix{width:100%;border-collapse:collapse;min-width:660px}.creon-matrix th,.creon-matrix td{padding:10px;border-bottom:1px solid var(--line);text-align:center;font-size:14px}.creon-matrix th{position:sticky;top:0;background:var(--soft);z-index:1}.creon-matrix th:first-child,.creon-matrix td:first-child{text-align:left;min-width:310px}.creon-matrix tr:last-child td{border-bottom:0}.creon-matrix input{accent-color:var(--brand)}
.creon-media{margin:16px 0 20px}.creon-media-card{border:1px solid var(--line);border-radius:16px;background:var(--soft);padding:12px;text-align:center}.creon-media img{display:block;width:100%;max-height:520px;object-fit:contain;border-radius:11px;background:#fff}.creon-media-fallback{min-height:220px;display:grid;place-items:center;color:var(--muted);padding:28px}.creon-gallery{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}.creon-gallery .creon-media-card{padding:9px}.creon-gallery strong{display:block;margin-bottom:7px}.creon-timer{text-align:center;color:var(--brand);font-weight:700;margin-top:10px}
.creon-actions{display:flex;align-items:center;gap:11px;margin-top:24px}.creon-spacer{flex:1}.creon-btn{border:0;border-radius:12px;padding:11px 18px;font-weight:750;cursor:pointer}.creon-btn-primary{background:var(--brand);color:#fff}.creon-btn-primary:hover{background:var(--brand2)}.creon-btn-secondary{background:transparent;color:var(--ink);border:1px solid var(--line)}.creon-btn:disabled{opacity:.48;cursor:not-allowed}.creon-progress{height:8px;background:var(--soft);border-radius:999px;overflow:hidden;margin-top:20px}.creon-progress>div{height:100%;background:linear-gradient(90deg,var(--brand),#7597ff);transition:width .25s}.creon-progress-text{text-align:center;color:var(--muted);font-size:12px;margin-top:7px}.creon-loading{position:fixed;inset:0;background:rgba(5,10,20,.54);backdrop-filter:blur(3px);display:grid;place-items:center;z-index:9999}.creon-spinner{width:50px;height:50px;border:4px solid rgba(255,255,255,.25);border-top-color:#fff;border-radius:50%;animation:creon-spin .8s linear infinite}@keyframes creon-spin{to{transform:rotate(360deg)}}
.creon-calibration-screen{position:fixed;inset:0;z-index:90000;background:radial-gradient(circle at 50% 20%,rgba(49,87,200,.16),transparent 38%),var(--bg);color:var(--ink);overflow:hidden}.creon-calibration-panel{position:relative;z-index:90003;width:min(760px,calc(100% - 32px));margin:clamp(12px,2.5vw,24px) auto;background:var(--card);border:1px solid var(--line);border-radius:20px;box-shadow:var(--shadow);padding:clamp(17px,2.5vw,22px);text-align:center}.creon-calibration-panel h1{font-size:clamp(20px,2.4vw,27px);margin:0 0 8px}.creon-calibration-panel p{color:var(--muted);margin:0 0 14px}.creon-guide-title{display:block;margin:4px 0 9px;color:var(--ink)}.creon-guide-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px;margin-bottom:12px;text-align:left}.creon-guide-card{display:grid;grid-template-columns:34px 1fr;align-items:start;gap:9px;border:1px solid var(--line);border-radius:13px;background:color-mix(in srgb,var(--soft) 62%,var(--card));padding:10px}.creon-guide-icon{width:34px;height:34px;display:grid;place-items:center;border-radius:10px;background:var(--brand);color:#fff;font-size:18px;line-height:1}.creon-guide-copy strong{display:block;font-size:12px;line-height:1.25;margin:1px 0 3px}.creon-guide-copy span{display:block;color:var(--muted);font-size:11px;line-height:1.3}.creon-calibration-reminder{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:8px;margin:9px 0}.creon-calibration-reminder span{display:inline-flex;align-items:center;gap:5px;border:1px solid var(--line);border-radius:999px;background:var(--soft);padding:5px 9px;color:var(--brand);font-size:12px;font-weight:750}.creon-calibration-point{position:absolute;z-index:90004;width:34px;height:34px;margin:-17px 0 0 -17px;border:4px solid #fff;border-radius:50%;background:var(--brand);box-shadow:0 0 0 5px rgba(49,87,200,.22),0 8px 24px rgba(15,23,42,.22);cursor:pointer;transition:transform .12s,opacity .12s}.creon-calibration-point:hover{transform:scale(1.12)}.creon-calibration-point.done{background:#12b76a;opacity:.42;cursor:default}.creon-calibration-point span{position:absolute;inset:50% auto auto 50%;transform:translate(-50%,-50%);font-size:11px;font-weight:800;color:#fff}.creon-tracking-status{text-align:center;color:var(--brand);font-weight:700;margin:14px 0}.creon-calibration-spinner{width:38px;height:38px;margin:16px auto;border:4px solid var(--line);border-top-color:var(--brand);border-radius:50%;animation:creon-spin .8s linear infinite}#webgazerVideoContainer{z-index:90002!important;pointer-events:none!important;border-radius:16px;overflow:hidden;box-shadow:0 18px 50px rgba(15,23,42,.3)}
.creon-face-status{padding:10px 12px;border-radius:12px;font-weight:750;margin:12px 0}.creon-face-status.checking{background:var(--soft);color:var(--brand)}.creon-face-status.present{background:rgba(18,183,106,.12);color:#087443}.creon-face-status.missing,.creon-face-status.blocked{background:rgba(180,35,24,.1);color:var(--danger)}.creon-face-warning{position:fixed;z-index:95000;top:16px;left:50%;transform:translateX(-50%);width:min(560px,calc(100% - 28px));background:#fff4ed;color:#9a3412;border:2px solid #fb923c;border-radius:16px;box-shadow:0 20px 55px rgba(15,23,42,.28);padding:16px 18px;text-align:center}.creon-face-warning strong{display:block;font-size:17px;margin-bottom:3px}.creon-face-warning span{display:block;font-size:14px}
.creon-recording-notice{margin:0 0 12px;padding:9px 11px;border:1px solid color-mix(in srgb,var(--brand) 35%,var(--line));border-radius:12px;background:var(--soft);color:var(--brand);font-size:11px;font-weight:700;line-height:1.35;text-align:left}
.creon-device-block{min-height:calc(100vh - 24px);display:grid;place-items:center;padding:16px}.creon-device-card{width:min(560px,100%);background:var(--card);border:1px solid var(--line);border-radius:var(--radius);box-shadow:var(--shadow);padding:clamp(24px,6vw,42px);text-align:center}.creon-device-icon{font-size:44px;line-height:1;margin-bottom:18px}.creon-device-card h1{font-size:clamp(22px,6vw,30px);line-height:1.2;margin:0 0 14px}.creon-device-card p{color:var(--muted);margin:0}.creon-device-card .creon-lang{width:max-content;margin:24px auto 0}
@media(prefers-color-scheme:dark){.creon-survey{--bg:#0c1220;--card:#141d2e;--ink:#f1f4fa;--muted:#aeb8ca;--line:#2d3950;--brand:#7d9cff;--brand2:#9bb0ff;--soft:#1c2a4a;--danger:#ff8a80;--shadow:0 22px 60px rgba(0,0,0,.35)}}
@media(max-width:680px){.creon-survey{padding:10px}.creon-topbar{align-items:center;margin-bottom:10px}.creon-lang button{padding:5px 9px}.creon-card{border-radius:17px}.creon-gallery{grid-template-columns:1fr}.creon-actions{margin-top:18px}.creon-actions .creon-btn{padding:10px 13px}.creon-matrix th:first-child,.creon-matrix td:first-child{min-width:210px}.creon-guide-grid{grid-template-columns:1fr}.creon-guide-copy span{font-size:12px}}
@media(prefers-reduced-motion:reduce){.creon-survey *{scroll-behavior:auto!important;transition:none!important;animation:none!important}}
`;

function shuffle(values) {
  const result = [...values];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

function parseRaw(id) {
  const row = RAW[id] || { ru: "", en: "" };
  const parse = (value) => {
    const lines = String(value || "").split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
    const firstOption = lines.findIndex((line) => /^\d+\.\s+/.test(line));
    const prompt = (firstOption < 0 ? lines : lines.slice(0, firstOption)).join("\n");
    const options = (firstOption < 0 ? [] : lines.slice(firstOption)).map((line) => {
      const match = line.match(/^(\d+)\.\s+(.*)$/);
      return match ? { code: match[1], label: match[2] } : null;
    }).filter(Boolean);
    return { prompt, options };
  };
  const ru = parse(row.ru);
  const en = parse(row.en);
  const optionMap = new Map();
  ru.options.forEach((option) => optionMap.set(option.code, { code: option.code, ru: option.label, en: "" }));
  en.options.forEach((option) => {
    const merged = optionMap.get(option.code) || { code: option.code, ru: "", en: "" };
    merged.en = option.label;
    optionMap.set(option.code, merged);
  });
  return { id, q: { ru: ru.prompt, en: en.prompt }, options: [...optionMap.values()], base: row.base, instruction: row.instruction };
}

function customOptions(labels) {
  return labels.map((label, index) => ({ code: String(index + 1), ...label }));
}

function step(id, type, extra = {}) {
  return { ...parseRaw(id), type, ...extra };
}

function cloneStep(source, suffix, extra = {}) {
  return { ...source, id: `${source.id}_${suffix}`, sourceId: source.id, concept: suffix, ...extra };
}

function buildSteps(conceptOrder, shelfVariant) {
  const scale = [1, 2, 3, 4, 5, 6, 7];
  const scale7 = { scale };
  const conceptBase = [
    step("ET2_INTRO", "timedInfo", { seconds: 10 }),
    step("ET2.1", "radio", { otherCode: "10" }),
    step("ET2.2", "checkbox", { optionsFrom: "ET2.1", otherCode: "10" }),
    step("ET2.3", "radio", { optionsFrom: "ET2.1", otherCode: "10" }),
    step("ET2.4", "checkbox", { optionsFrom: "ET2.1", allowedCodes: ["1", "2", "3", "4", "5", "6", "7", "8", "9"] }),
    step("P1", "rating", scale7),
    step("P2", "matrix", { scale, rotateGroups: [["1", "2", "3", "4", "5", "6"], ["7", "8", "9", "10", "11", "12"], ["13", "14", "15", "16", "17", "18", "19", "20"], ["21", "22"]] }),
    step("P3", "matrix", scale7), step("P4", "rating", scale7),
    step("P5a", "radio"), step("P5b", "checkbox", { rotate: ["1", "2", "3", "4", "5", "6", "7", "8"], otherCode: "11" }), step("P5c", "rating", scale7),
    step("P6a", "checkbox", { exclusive: ["3"] }),
    step("P6b", "matrix", { dynamicItemsFrom: "P6a", scale }), step("P6c", "matrix", { dynamicItemsFrom: "P6a", scale }),
    step("P6d", "matrix", { dynamicItemsFrom: "P6a", scale }), step("P6e", "matrix", { dynamicItemsFrom: "P6a", scale }),
    step("P7", "matrix", scale7), step("P8a", "radio"), step("P8b", "rating", scale7), step("P8c", "rating", scale7),
    step("P9", "checkbox", { exclusive: ["12"], otherCode: "11" }),
  ];
  const conceptSteps = conceptOrder.flatMap((concept) => conceptBase.map((source) => cloneStep(source, concept, {
    asset: source.id === "ET2_INTRO" ? `pack-${concept.toLowerCase()}.jpg` : (/^P/.test(source.id) ? `pack-${concept.toLowerCase()}.jpg` : null),
  })));
  const comparisonChoices = customOptions([
    { ru: "Упаковка A", en: "Pack A" }, { ru: "Упаковка B", en: "Pack B" },
    { ru: "Текущая упаковка", en: "Current pack" }, { ru: "Одинаково", en: "Equally" }, { ru: "Ни одна", en: "None" },
  ]);
  const c3Items = customOptions([{ ru: "Новая упаковка A", en: "New pack A" }, { ru: "Новая упаковка B", en: "New pack B" }]);
  return [
    step("INTRO", "info"), step("Q0", "radio"), step("S11", "checkbox", { exclusive: ["11"] }),
    step("S1", "radio"), step("S2", "number"), step("S3", "radio"), step("S4", "radio"),
    step("S6", "checkbox", { exclusive: ["8"], otherCode: "7" }), step("S7", "checkbox", { max: 4, exclusive: ["99"] }),
    step("S8", "radio"), step("S9", "checkbox", { otherCode: "7" }), step("S10", "radio", { condition: "nonCreon" }),
    step("Q1", "radio"), step("Q2", "checkbox", { rotate: ["1", "2", "3", "4", "5", "6", "7"], otherCode: "8" }),
    step("Q3", "matrix", scale7), step("ET0", "radio"),
    step("ET_TEST1_INTRO", "timedInfo", { seconds: 9, asset: `shelf-${shelfVariant.toLowerCase()}.jpg` }),
    step("ET1.1", "checkbox", { exclusive: ["6"] }), step("ET1.2", "radio"),
    step("ET1.3", "radio", { optionsFrom: "ET1.2" }), step("ET1.4", "radio", { optionsFrom: "ET1.2" }),
    ...conceptSteps,
    step("C1", "radio", { gallery: true }), step("C2", "matrix", { choices: comparisonChoices, gallery: true }),
    step("C3", "matrix", { items: c3Items, scale, gallery: true }), step("C4", "radio", { gallery: true }),
    step("C5", "radio", { gallery: true }), step("C6", "radio", { gallery: true }),
    step("C7", "checkbox", { max: 3, otherCode: "9" }), step("C8", "text"),
  ];
}

function makeReference() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const numbers = new Uint32Array(7);
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) window.crypto.getRandomValues(numbers);
  else numbers.forEach((_, index) => { numbers[index] = Math.floor(Math.random() * 1e9); });
  return [...numbers].map((number) => chars[number % chars.length]).join("");
}

function getQueryParams() {
  if (typeof window === "undefined") return new URLSearchParams();

  const params = new URLSearchParams(window.location.search);
  const hashQueryIndex = window.location.hash.indexOf("?");

  if (hashQueryIndex >= 0) {
    const hashParams = new URLSearchParams(window.location.hash.slice(hashQueryIndex + 1));
    hashParams.forEach((value, key) => {
      if (!params.has(key)) params.set(key, value);
    });
  }

  return params;
}

function localized(value, language) {
  return value && typeof value === "object" ? (value[language] || value.en || value.ru || "") : String(value || "");
}

function getOptions(currentStep, stepById, orderCache) {
  let options = currentStep.options || [];
  if (currentStep.optionsFrom) options = (stepById[currentStep.optionsFrom] || parseRaw(currentStep.optionsFrom)).options || [];
  if (currentStep.allowedCodes) options = options.filter((option) => currentStep.allowedCodes.includes(option.code));
  if (currentStep.rotate) {
    if (!orderCache[currentStep.id]) {
      orderCache[currentStep.id] = [
        ...shuffle(options.filter((option) => currentStep.rotate.includes(option.code))),
        ...options.filter((option) => !currentStep.rotate.includes(option.code)),
      ].map((option) => option.code);
    }
    const byCode = Object.fromEntries(options.map((option) => [option.code, option]));
    options = orderCache[currentStep.id].map((code) => byCode[code]).filter(Boolean);
  }
  return options;
}

function getItems(currentStep, answers, stepById, optionCache, itemCache) {
  if (currentStep.dynamicItemsFrom) {
    const sourceId = `${currentStep.dynamicItemsFrom}_${currentStep.concept}`;
    const sourceStep = stepById[sourceId];
    const selected = answers[sourceId] || [];
    return getOptions(sourceStep, stepById, optionCache).filter((option) => selected.includes(option.code) && option.code !== "3");
  }
  let items = currentStep.items || currentStep.options || [];
  if (currentStep.rotateGroups) {
    if (!itemCache[currentStep.id]) itemCache[currentStep.id] = currentStep.rotateGroups.flatMap((group) => shuffle(group));
    const byCode = Object.fromEntries(items.map((item) => [item.code, item]));
    items = itemCache[currentStep.id].map((code) => byCode[code]).filter(Boolean);
  }
  return items;
}

function isVisible(currentStep, answers) {
  if (currentStep.condition === "nonCreon" && (answers.S9 || []).includes("1")) return false;
  if (["P5b", "P5c"].includes(currentStep.sourceId)) return answers[`P5a_${currentStep.concept}`] === "1";
  if (/^P6[b-e]$/.test(currentStep.sourceId || "")) {
    const selected = answers[`P6a_${currentStep.concept}`] || [];
    return selected.includes("1") || selected.includes("2");
  }
  return true;
}

function screenoutReason(currentStep, value) {
  if (currentStep.id === "Q0" && value === "2") return "consent_declined";
  if (currentStep.id === "S11" && value.some((code) => code !== "11")) return "industry";
  if (currentStep.id === "S1" && value === "1") return "gender";
  if (currentStep.id === "S2" && (value < 25 || value > 55)) return "age";
  if (currentStep.id === "S4" && value === "1") return "income";
  if (currentStep.id === "S7" && !value.includes("1")) return "category_use";
  if (currentStep.id === "S8" && value !== "1") return "purchase_role";
  if (currentStep.id === "S10" && value === "2") return "creon_consideration";
  return "";
}

function draftForStep(currentStep, answers) {
  const stored = answers[currentStep.id];
  if (["info", "timedInfo"].includes(currentStep.type)) return true;
  if (currentStep.type === "checkbox") return Array.isArray(stored) ? stored : [];
  if (currentStep.type === "matrix") return stored && typeof stored === "object" ? stored : {};
  return stored ?? "";
}

function MediaCard({ src, label, missing }) {
  const [failed, setFailed] = useState(false);
  const h = React.createElement;
  return h("div", { className: "creon-media-card" },
    h("strong", null, label),
    !failed && h("img", { src, alt: label, onError: () => setFailed(true) }),
    failed && h("div", { className: "creon-media-fallback" }, h("span", null, missing, h("br"), h("small", null, src))),
  );
}

export default function CreonSurvey({
  projectId: projectIdProp = "creon_consumers_ru_en",
  participantId: participantIdProp,
  initialLanguage,
  assetBaseUrl = "",
  onComplete,
}) {
  const h = React.createElement;
  const query = useMemo(getQueryParams, []);
  const mobileBrowser = useMemo(detectMobileBrowser, []);
  const [language, setLanguage] = useState(() => initialLanguage || (query.get("lang") === "ru" ? "ru" : "en"));
  const [conceptOrder, setConceptOrder] = useState(["A", "B"]);
  const [shelfVariant, setShelfVariant] = useState("A");
  const steps = useMemo(() => buildSteps(conceptOrder, shelfVariant), [conceptOrder, shelfVariant]);
  const stepById = useMemo(() => Object.fromEntries(steps.map((item) => [item.id, item])), [steps]);
  const optionCache = useRef({});
  const itemCache = useRef({});
  const reference = useRef(makeReference());
  const startedAt = useRef(new Date().toISOString());
  const [answers, setAnswers] = useState({});
  const [history, setHistory] = useState([]);
  const [navigation, setNavigation] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [draft, setDraft] = useState(true);
  const [otherDraft, setOtherDraft] = useState("");
  const [error, setError] = useState("");
  const [timersDone, setTimersDone] = useState({});
  const [timerRemaining, setTimerRemaining] = useState(0);
  const [saving, setSaving] = useState(false);
  const [endStatus, setEndStatus] = useState("");
  const [pendingSubmission, setPendingSubmission] = useState(null);
  const [calibrationStatus, setCalibrationStatus] = useState("idle");
  const [calibrationError, setCalibrationError] = useState("");
  const [calibrationCounts, setCalibrationCounts] = useState(() => CALIBRATION_POINTS.map(() => 0));
  const [gazeRecordingReady, setGazeRecordingReady] = useState(false);
  const [facePresenceStatus, setFacePresenceStatus] = useState("detecting");
  const [eyeVisibilityStatus, setEyeVisibilityStatus] = useState("checking");
  const webgazerRef = useRef(null);
  const webgazerStartedRef = useRef(false);
  const calibrationCountsRef = useRef(CALIBRATION_POINTS.map(() => 0));
  const calibrationFinishingRef = useRef(false);
  const calibrationMetaRef = useRef(null);
  const gazeRecordingsRef = useRef({});
  const activeGazeRecordingRef = useRef(null);
  const cameraRecordingsRef = useRef({});
  const activeCameraRecordingRef = useRef(null);
  const pendingCameraUploadsRef = useRef([]);
  const facePresenceStatusRef = useRef("detecting");
  const faceDetectionStartedAtRef = useRef(0);
  const faceStableSinceRef = useRef(0);
  const lastFaceSeenAtRef = useRef(0);
  const faceAbsenceEventsRef = useRef([]);
  const activeFaceAbsenceRef = useRef(null);
  const eyeVisibilityStatusRef = useRef("checking");
  const eyewearDecisionSamplesRef = useRef([]);
  const lastEyewearCheckAtRef = useRef(0);
  const trackingContextRef = useRef({ questionNumber: 1, stepId: "INTRO" });

  const currentStep = steps[currentIndex];
  const ui = UI[language];
  const currentOptions = getOptions(currentStep, stepById, optionCache.current);
  const currentItems = getItems(currentStep, answers, stepById, optionCache.current, itemCache.current);
  const assetPath = (name) => `${String(assetBaseUrl || "").replace(/\/$/, "")}/${name}`;
  const participantId = participantIdProp ?? query.get("participant_id") ?? "";
  const surveyCode = query.get("survey_code") || query.get("project_id") || projectIdProp;
  const questionNumber = currentIndex + 1;
  const isTrackedQuestion = TRACKED_QUESTION_NUMBERS.includes(questionNumber);
  trackingContextRef.current = { questionNumber, stepId: currentStep.id };

  const finalizeGazeRecording = useCallback(() => {
    const recording = activeGazeRecordingRef.current;
    if (!recording) return;

    const endedAtPerformance = performance.now();
    gazeRecordingsRef.current = {
      ...gazeRecordingsRef.current,
      [recording.key]: {
        question_number: recording.questionNumber,
        step_id: recording.stepId,
        concept: recording.concept,
        started_at: recording.startedAt,
        ended_at: new Date().toISOString(),
        duration_ms: Math.round(endedAtPerformance - recording.startedAtPerformance),
        viewport: recording.viewport,
        sample_count: recording.samples.length,
        samples: recording.samples,
      },
    };
    activeGazeRecordingRef.current = null;
  }, []);

  const startCameraRecording = useCallback((recordingContext) => {
    const { key, questionNumber: trackedQuestionNumber, stepId, concept, startedAt, startedAtPerformance } = recordingContext;
    const baseMetadata = {
      question_number: trackedQuestionNumber,
      step_id: stepId,
      concept,
      started_at: startedAt,
      synchronized_with: `eye_tracking.recordings.${key}`,
    };
    const format = getCameraRecordingFormat();
    if (!format) {
      cameraRecordingsRef.current = {
        ...cameraRecordingsRef.current,
        [key]: { ...baseMetadata, status: "unsupported", error: "MediaRecorder is not supported" },
      };
      return false;
    }

    try {
      const videoElement = document.getElementById("webgazerVideoFeed");
      const sourceStream = videoElement?.srcObject;
      const videoTracks = sourceStream?.getVideoTracks?.() || [];
      if (!videoTracks.length) throw new Error("WebGazer camera stream is unavailable");

      const recordingStream = new MediaStream(videoTracks);
      const recorderOptions = {
        videoBitsPerSecond: 650000,
        ...(format.mimeType ? { mimeType: format.mimeType } : {}),
      };
      const recorder = new MediaRecorder(recordingStream, recorderOptions);
      const chunks = [];
      recorder.addEventListener("dataavailable", (event) => {
        if (event.data?.size) chunks.push(event.data);
      });
      recorder.start(500);
      activeCameraRecordingRef.current = {
        ...recordingContext,
        recorder,
        chunks,
        extension: format.extension,
        mimeType: recorder.mimeType || format.mimeType,
        recorderStartedAtPerformance: performance.now(),
      };
      return true;
    } catch (cameraRecordingError) {
      cameraRecordingsRef.current = {
        ...cameraRecordingsRef.current,
        [key]: {
          ...baseMetadata,
          status: "failed_to_start",
          error: cameraRecordingError instanceof Error ? cameraRecordingError.message : String(cameraRecordingError),
          duration_ms: Math.round(performance.now() - startedAtPerformance),
        },
      };
      return false;
    }
  }, []);

  const finalizeCameraRecording = useCallback(() => {
    const recording = activeCameraRecordingRef.current;
    if (!recording) return Promise.resolve();
    activeCameraRecordingRef.current = null;

    const endedAt = new Date().toISOString();
    const durationMs = Math.round(performance.now() - recording.startedAtPerformance);
    const baseMetadata = {
      question_number: recording.questionNumber,
      step_id: recording.stepId,
      concept: recording.concept,
      started_at: recording.startedAt,
      ended_at: endedAt,
      duration_ms: durationMs,
      camera_start_offset_ms: Math.round(recording.recorderStartedAtPerformance - recording.startedAtPerformance),
      synchronized_with: `eye_tracking.recordings.${recording.key}`,
    };

    const uploadPromise = new Promise((resolve) => {
      let finalized = false;
      const uploadRecording = async () => {
        if (finalized) return;
        finalized = true;
        const contentType = recording.recorder.mimeType || recording.mimeType || "video/webm";
        const blob = new Blob(recording.chunks, { type: contentType });

        if (!blob.size) {
          cameraRecordingsRef.current = {
            ...cameraRecordingsRef.current,
            [recording.key]: { ...baseMetadata, status: "empty", content_type: contentType, byte_size: 0 },
          };
          resolve();
          return;
        }

        try {
          const uploaded = await uploadSurveyCameraRecording({
            surveyCode,
            responseId: reference.current,
            questionNumber: recording.questionNumber,
            stepId: recording.stepId,
            blob,
            extension: recording.extension,
          });
          cameraRecordingsRef.current = {
            ...cameraRecordingsRef.current,
            [recording.key]: { ...baseMetadata, status: "uploaded", ...uploaded },
          };
        } catch (cameraUploadError) {
          cameraRecordingsRef.current = {
            ...cameraRecordingsRef.current,
            [recording.key]: {
              ...baseMetadata,
              status: "upload_failed",
              content_type: contentType,
              byte_size: blob.size,
              error: cameraUploadError instanceof Error ? cameraUploadError.message : String(cameraUploadError),
            },
          };
        }
        resolve();
      };

      recording.recorder.addEventListener("stop", uploadRecording, { once: true });
      if (recording.recorder.state === "inactive") uploadRecording();
      else {
        try {
          recording.recorder.stop();
        } catch (cameraStopError) {
          uploadRecording();
        }
      }
    });

    pendingCameraUploadsRef.current = [...pendingCameraUploadsRef.current, uploadPromise];
    return uploadPromise;
  }, [surveyCode]);

  const finalizeFaceAbsence = useCallback(() => {
    const absence = activeFaceAbsenceRef.current;
    if (!absence) return;

    const endedAtPerformance = performance.now();
    faceAbsenceEventsRef.current = [
      ...faceAbsenceEventsRef.current,
      {
        ...absence,
        ended_at: new Date().toISOString(),
        duration_ms: Math.round(endedAtPerformance - absence.startedAtPerformance),
      },
    ];
    activeFaceAbsenceRef.current = null;
  }, []);

  const updateFacePresence = useCallback((hasFace) => {
    const now = performance.now();

    if (hasFace) {
      lastFaceSeenAtRef.current = now;
      if (!faceStableSinceRef.current) faceStableSinceRef.current = now;

      if (
        now - faceStableSinceRef.current >= FACE_CONFIRMATION_MS
        && facePresenceStatusRef.current !== "present"
      ) {
        facePresenceStatusRef.current = "present";
        setFacePresenceStatus("present");
        finalizeFaceAbsence();
      }
      return;
    }

    faceStableSinceRef.current = 0;
    const lastDetection = lastFaceSeenAtRef.current || faceDetectionStartedAtRef.current;
    if (
      now - lastDetection >= FACE_MISSING_WARNING_MS
      && facePresenceStatusRef.current !== "missing"
    ) {
      const wasPresent = facePresenceStatusRef.current === "present";
      facePresenceStatusRef.current = "missing";
      setFacePresenceStatus("missing");

      if (wasPresent && calibrationMetaRef.current && !activeFaceAbsenceRef.current) {
        const absenceStartedAt = lastFaceSeenAtRef.current || now;
        activeFaceAbsenceRef.current = {
          started_at: new Date(Date.now() - (now - absenceStartedAt)).toISOString(),
          startedAtPerformance: absenceStartedAt,
          question_number: trackingContextRef.current.questionNumber,
          step_id: trackingContextRef.current.stepId,
        };
      }
    }
  }, [finalizeFaceAbsence]);

  const resetEyeVisibilityCheck = useCallback(() => {
    eyewearDecisionSamplesRef.current = [];
    lastEyewearCheckAtRef.current = 0;
    if (eyeVisibilityStatusRef.current !== "checking") {
      eyeVisibilityStatusRef.current = "checking";
      setEyeVisibilityStatus("checking");
    }
  }, []);

  const updateEyeVisibility = useCallback((darkEyewearDetected) => {
    if (typeof darkEyewearDetected !== "boolean") return;
    const samples = [...eyewearDecisionSamplesRef.current, darkEyewearDetected]
      .slice(-EYEWEAR_DECISION_SAMPLE_COUNT);
    eyewearDecisionSamplesRef.current = samples;
    if (samples.length < EYEWEAR_DECISION_SAMPLE_COUNT) return;

    const darkSampleCount = samples.filter(Boolean).length;
    const nextStatus = darkSampleCount >= Math.ceil(EYEWEAR_DECISION_SAMPLE_COUNT * 0.625)
      ? "blocked"
      : "clear";
    if (eyeVisibilityStatusRef.current !== nextStatus) {
      eyeVisibilityStatusRef.current = nextStatus;
      setEyeVisibilityStatus(nextStatus);
    }
  }, []);

  const shutdownWebGazer = useCallback(() => {
    if (!webgazerStartedRef.current) return;
    const tracker = webgazerRef.current;
    if (!tracker) return;

    try { tracker.clearGazeListener(); } catch (shutdownError) { console.warn(shutdownError); }
    try { tracker.stopVideo(); } catch (shutdownError) { console.warn(shutdownError); }
    try { tracker.end(); } catch (shutdownError) { console.warn(shutdownError); }
    webgazerStartedRef.current = false;
  }, []);

  useEffect(() => {
    setConceptOrder(Math.random() < 0.5 ? ["A", "B"] : ["B", "A"]);
    setShelfVariant(Math.random() < 0.5 ? "A" : "B");
  }, []);

  useEffect(() => () => {
    finalizeGazeRecording();
    finalizeCameraRecording();
    shutdownWebGazer();
  }, [finalizeCameraRecording, finalizeGazeRecording, shutdownWebGazer]);

  useEffect(() => {
    if (calibrationStatus !== "camera") return undefined;

    const positionCameraPreview = () => {
      const videoContainer = document.getElementById("webgazerVideoContainer");
      const calibrationPanel = document.querySelector(".creon-calibration-panel");
      if (!videoContainer || !calibrationPanel) return;

      const panelBounds = calibrationPanel.getBoundingClientRect();
      videoContainer.style.left = "50%";
      videoContainer.style.top = `${Math.ceil(panelBounds.bottom + 40)}px`;
      videoContainer.style.transform = "translateX(-50%)";
    };

    let secondFrame = 0;
    const firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(positionCameraPreview);
    });
    const panel = document.querySelector(".creon-calibration-panel");
    const resizeObserver = typeof ResizeObserver !== "undefined" && panel
      ? new ResizeObserver(positionCameraPreview)
      : null;
    resizeObserver?.observe(panel);
    window.addEventListener("resize", positionCameraPreview);

    return () => {
      window.cancelAnimationFrame(firstFrame);
      if (secondFrame) window.cancelAnimationFrame(secondFrame);
      resizeObserver?.disconnect();
      window.removeEventListener("resize", positionCameraPreview);
    };
  }, [calibrationStatus, eyeVisibilityStatus, facePresenceStatus, language]);

  useEffect(() => {
    setDraft(draftForStep(currentStep, answers));
    setOtherDraft(answers[`${currentStep.id}_OTHER`] || "");
    setError("");
  }, [answers, currentStep]);

  useEffect(() => {
    if (currentStep.type !== "timedInfo" || timersDone[currentStep.id]) {
      setTimerRemaining(0);
      return undefined;
    }
    if (isTrackedQuestion && !gazeRecordingReady) {
      setTimerRemaining(0);
      return undefined;
    }
    setTimerRemaining(currentStep.seconds);
    const timer = window.setInterval(() => {
      setTimerRemaining((previous) => {
        if (previous <= 1) {
          window.clearInterval(timer);
          setTimersDone((done) => ({ ...done, [currentStep.id]: true }));
          return 0;
        }
        return previous - 1;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, [currentStep.id, currentStep.seconds, currentStep.type, gazeRecordingReady, isTrackedQuestion, timersDone]);

  useEffect(() => {
    const shouldRecord = calibrationStatus === "completed"
      && isTrackedQuestion
      && !timersDone[currentStep.id];
    let cancelled = false;

    if (!shouldRecord) {
      setGazeRecordingReady(false);
      if (activeGazeRecordingRef.current) finalizeGazeRecording();
      if (activeCameraRecordingRef.current) finalizeCameraRecording();
      return undefined;
    }

    setGazeRecordingReady(false);
    const startRecording = async () => {
      try {
        await webgazerRef.current?.resume();
        if (cancelled) return;

        const synchronizedStartedAt = new Date().toISOString();
        const synchronizedStartedAtPerformance = performance.now();
        const recordingContext = {
          key: `question_${questionNumber}`,
          questionNumber,
          stepId: currentStep.id,
          concept: currentStep.concept || null,
          startedAt: synchronizedStartedAt,
          startedAtPerformance: synchronizedStartedAtPerformance,
        };
        startCameraRecording(recordingContext);
        activeGazeRecordingRef.current = {
          ...recordingContext,
          viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
            device_pixel_ratio: window.devicePixelRatio || 1,
          },
          samples: [],
        };
        setGazeRecordingReady(true);
      } catch (trackingError) {
        console.error("WebGazer recording could not be started:", trackingError);
        setError(ui.calibrationError);
      }
    };

    startRecording();

    return () => {
      cancelled = true;
      finalizeGazeRecording();
      finalizeCameraRecording();
    };
  }, [calibrationStatus, currentStep.concept, currentStep.id, finalizeCameraRecording, finalizeGazeRecording, isTrackedQuestion, questionNumber, startCameraRecording, timersDone, ui.calibrationError]);

  const isValid = (() => {
    if (currentStep.type === "info") return true;
    if (currentStep.type === "timedInfo") return Boolean(timersDone[currentStep.id]);
    if (currentStep.type === "checkbox") {
      if (!Array.isArray(draft) || draft.length === 0 || (currentStep.max && draft.length > currentStep.max)) return false;
      return !(currentStep.otherCode && draft.includes(currentStep.otherCode) && !otherDraft.trim());
    }
    if (currentStep.type === "radio") return Boolean(draft) && !(currentStep.otherCode && draft === currentStep.otherCode && !otherDraft.trim());
    if (currentStep.type === "matrix") return Object.keys(draft || {}).length === currentItems.length;
    if (currentStep.type === "number") return Number(draft) > 0;
    return String(draft || "").trim().length > 0;
  })();

  const findNext = (from, nextAnswers) => {
    for (let index = from + 1; index < steps.length; index += 1) if (isVisible(steps[index], nextAnswers)) return index;
    return -1;
  };

  const startWebGazerCalibration = async () => {
    setCalibrationStatus("starting");
    setCalibrationError("");
    setFacePresenceStatus("detecting");
    facePresenceStatusRef.current = "detecting";
    resetEyeVisibilityCheck();
    faceDetectionStartedAtRef.current = performance.now();
    faceStableSinceRef.current = 0;
    lastFaceSeenAtRef.current = 0;
    calibrationFinishingRef.current = false;
    calibrationCountsRef.current = CALIBRATION_POINTS.map(() => 0);
    setCalibrationCounts([...calibrationCountsRef.current]);

    try {
      const webgazerModule = await import("../webgazer/webgazer");
      const tracker = webgazerModule.default;
      webgazerRef.current = tracker;

      if (!tracker.detectCompatibility()) throw new Error("Camera API is not supported");

      webgazerStartedRef.current = true;
      tracker
        .saveDataAcrossSessions(false)
        .setRegression("ridge")
        .setTracker("TFFacemesh")
        .applyKalmanFilter(true)
        .showVideoPreview(true)
        .showPredictionPoints(false)
        .setGazeListener((data, elapsedTime) => {
          const facePositions = tracker.getTracker()?.getPositions?.();
          const hasFace = Array.isArray(facePositions) && facePositions.length > 0;
          updateFacePresence(hasFace);

          if (!hasFace) {
            resetEyeVisibilityCheck();
          } else if (performance.now() - lastEyewearCheckAtRef.current >= EYEWEAR_CHECK_INTERVAL_MS) {
            lastEyewearCheckAtRef.current = performance.now();
            updateEyeVisibility(detectDarkEyewear(tracker));
          }

          const recording = activeGazeRecordingRef.current;
          if (!recording || !data || !Number.isFinite(data.x) || !Number.isFinite(data.y)) return;
          if (recording.samples.length >= MAX_GAZE_SAMPLES_PER_RECORDING) return;

          recording.samples.push({
            x: Math.round(data.x * 100) / 100,
            y: Math.round(data.y * 100) / 100,
            t_ms: Math.round(performance.now() - recording.startedAtPerformance),
            webgazer_time_ms: Math.round(elapsedTime),
          });
        });

      await tracker.clearData();
      await tracker.begin();
      tracker.removeMouseEventListeners();

      const previewWidth = Math.max(180, Math.min(320, window.innerWidth - 32));
      tracker.setVideoViewerSize(previewWidth, Math.round(previewWidth * 0.75));
      setCalibrationStatus("camera");
    } catch (trackingError) {
      console.error("WebGazer calibration could not be started:", trackingError);
      shutdownWebGazer();
      setCalibrationError(ui.calibrationError);
      setCalibrationStatus("error");
    }
  };

  const showCalibrationPoints = () => {
    if (facePresenceStatusRef.current !== "present" || eyeVisibilityStatusRef.current !== "clear") return;
    webgazerRef.current?.showVideoPreview(false).showPredictionPoints(false);
    setCalibrationStatus("active");
  };

  const finishCalibration = () => {
    if (calibrationFinishingRef.current) return;
    calibrationFinishingRef.current = true;

    calibrationMetaRef.current = {
      status: "completed",
      completed_at: new Date().toISOString(),
      required_clicks_per_point: CALIBRATION_CLICKS_PER_POINT,
      total_clicks: CALIBRATION_POINTS.length * CALIBRATION_CLICKS_PER_POINT,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        device_pixel_ratio: window.devicePixelRatio || 1,
      },
      points: CALIBRATION_POINTS.map((point, index) => ({
        x_percent: point.x,
        y_percent: point.y,
        clicks: calibrationCountsRef.current[index],
      })),
    };

    webgazerRef.current?.showVideoPreview(false).showPredictionPoints(false);
    setCalibrationStatus("completed");

    const nextIndex = findNext(currentIndex, answers);
    if (nextIndex >= 0) {
      setNavigation((items) => [...items, currentIndex]);
      setDraft(draftForStep(steps[nextIndex], answers));
      setOtherDraft(answers[`${steps[nextIndex].id}_OTHER`] || "");
      setCurrentIndex(nextIndex);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCalibrationPoint = (pointIndex, event) => {
    if (calibrationStatus !== "active" || calibrationFinishingRef.current) return;
    if (facePresenceStatusRef.current !== "present" || eyeVisibilityStatusRef.current !== "clear") return;
    if (calibrationCountsRef.current[pointIndex] >= CALIBRATION_CLICKS_PER_POINT) return;

    const bounds = event.currentTarget.getBoundingClientRect();
    webgazerRef.current?.recordScreenPosition(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2, "click");

    calibrationCountsRef.current[pointIndex] += 1;
    const nextCounts = [...calibrationCountsRef.current];
    setCalibrationCounts(nextCounts);

    if (nextCounts.every((count) => count >= CALIBRATION_CLICKS_PER_POINT)) {
      window.setTimeout(finishCalibration, 250);
    }
  };

  const labelFor = (surveyStep, code) => {
    const option = getOptions(surveyStep, stepById, optionCache.current).find((item) => item.code === String(code));
    return option ? localized(option, language) : String(code);
  };

  const answerLabels = (finalAnswers) => {
    const result = {};
    steps.forEach((surveyStep) => {
      const value = finalAnswers[surveyStep.id];
      if (value === undefined) return;
      if (surveyStep.type === "radio") result[surveyStep.id] = labelFor(surveyStep, value);
      else if (surveyStep.type === "checkbox") result[surveyStep.id] = value.map((code) => labelFor(surveyStep, code));
      else result[surveyStep.id] = value;
      if (finalAnswers[`${surveyStep.id}_OTHER`]) result[`${surveyStep.id}_OTHER`] = finalAnswers[`${surveyStep.id}_OTHER`];
    });
    return result;
  };

  const sendCompletion = async (submission) => {
    setSaving(true);
    setError("");
    finalizeGazeRecording();
    finalizeFaceAbsence();
    finalizeCameraRecording();
    await Promise.allSettled([...pendingCameraUploadsRef.current]);
    const completed = {
      survey_code: surveyCode, response_id: reference.current, participant_id: participantId,
      event: `survey_${submission.status}`, status: submission.status, screenout_reason: submission.reason,
      started_at: startedAt.current, completed_at: new Date().toISOString(), language,
      concept_order: conceptOrder, shelf_variant: shelfVariant, answers: submission.answers,
      answer_labels: answerLabels(submission.answers), history: submission.history,
      eye_tracking: {
        engine: "webgazer",
        calibration: calibrationMetaRef.current,
        recordings: gazeRecordingsRef.current,
        camera_recordings: cameraRecordingsRef.current,
        face_absence_events: faceAbsenceEventsRef.current,
        eye_visibility_check: {
          method: "relative_eye_luminance",
          final_status: eyeVisibilityStatusRef.current,
        },
      },
    };
    try {
      await saveSurveyResult({
        surveyCode,
        responseId: reference.current,
        result: completed,
      });

      setPendingSubmission(null);
      setEndStatus(submission.status);
      shutdownWebGazer();
      if (onComplete) onComplete(completed);
    } catch (submissionError) {
      console.error("Survey result could not be saved to Firestore:", submissionError);
      setError(ui.network);
      setPendingSubmission(submission);
    } finally {
      setSaving(false);
    }
  };

  const handleNext = async () => {
    if (mobileBrowser) return;
    if (currentIndex === 0 && calibrationStatus !== "completed") {
      if (!["starting", "camera", "active"].includes(calibrationStatus)) await startWebGazerCalibration();
      return;
    }
    if (pendingSubmission) {
      await sendCompletion(pendingSubmission);
      return;
    }
    if (!isValid) {
      setError(ui.required);
      return;
    }
    let nextAnswers = { ...answers };
    let nextHistory = [...history];
    let value = draft;
    if (currentStep.type === "number") value = Number(draft);
    if (!["info", "timedInfo"].includes(currentStep.type)) {
      if (nextAnswers[currentStep.id] !== undefined && JSON.stringify(nextAnswers[currentStep.id]) !== JSON.stringify(value)) {
        steps.slice(currentIndex + 1).forEach((item) => {
          delete nextAnswers[item.id];
          delete nextAnswers[`${item.id}_OTHER`];
        });
        const downstream = new Set(steps.slice(currentIndex + 1).map((item) => item.id));
        nextHistory = nextHistory.filter((entry) => !downstream.has(entry.id));
      }
      nextAnswers[currentStep.id] = value;
      if (currentStep.otherCode && value.includes(currentStep.otherCode)) nextAnswers[`${currentStep.id}_OTHER`] = otherDraft.trim();
      else delete nextAnswers[`${currentStep.id}_OTHER`];
      nextHistory.push({ id: currentStep.id, source_id: currentStep.sourceId || currentStep.id, concept: currentStep.concept || null, language, question: localized(currentStep.q, language), answer: value, at: new Date().toISOString() });
      setAnswers(nextAnswers);
      setHistory(nextHistory);
    }
    const reason = screenoutReason(currentStep, value);
    if (reason) {
      await sendCompletion({ status: "screened_out", reason, answers: nextAnswers, history: nextHistory });
      return;
    }
    const nextIndex = findNext(currentIndex, nextAnswers);
    if (nextIndex < 0) {
      await sendCompletion({ status: "completed", reason: "", answers: nextAnswers, history: nextHistory });
      return;
    }
    setNavigation((items) => [...items, currentIndex]);
    setDraft(draftForStep(steps[nextIndex], nextAnswers));
    setOtherDraft(nextAnswers[`${steps[nextIndex].id}_OTHER`] || "");
    setCurrentIndex(nextIndex);
    if (typeof window !== "undefined") window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = () => {
    if (!navigation.length || saving) return;
    const previous = navigation[navigation.length - 1];
    setNavigation((items) => items.slice(0, -1));
    setDraft(draftForStep(steps[previous], answers));
    setOtherDraft(answers[`${steps[previous].id}_OTHER`] || "");
    setCurrentIndex(previous);
    setPendingSubmission(null);
  };

  const handleCheckbox = (code, checked) => {
    let selected = Array.isArray(draft) ? [...draft] : [];
    if (checked) selected = [...selected, code];
    else selected = selected.filter((item) => item !== code);
    if (checked && currentStep.exclusive?.includes(code)) selected = [code];
    else if (checked && currentStep.exclusive) selected = selected.filter((item) => !currentStep.exclusive.includes(item));
    if (currentStep.max && selected.length > currentStep.max) {
      setError(ui.max(currentStep.max));
      return;
    }
    setError("");
    setDraft(selected);
  };

  useEffect(() => {
    const keyboardSubmit = (event) => {
      if (!mobileBrowser && (event.ctrlKey || event.metaKey) && event.key === "Enter" && isValid && !saving && !endStatus) handleNext();
    };
    document.addEventListener("keydown", keyboardSubmit);
    return () => document.removeEventListener("keydown", keyboardSubmit);
  });

  if (mobileBrowser) return h("div", { className: "creon-survey", lang: language },
    h("style", null, SURVEY_CSS),
    h("main", { className: "creon-device-block" },
      h("section", { className: "creon-device-card", role: "alert" },
        h("div", { className: "creon-device-icon", "aria-hidden": "true" }, "🖥️"),
        h("h1", null, ui.desktopOnlyTitle),
        h("p", null, ui.desktopOnlyBody),
        h("div", { className: "creon-lang", role: "group", "aria-label": "Language" },
          h("button", { type: "button", className: language === "en" ? "active" : "", onClick: () => setLanguage("en") }, "EN"),
          h("button", { type: "button", className: language === "ru" ? "active" : "", onClick: () => setLanguage("ru") }, "RU"),
        ),
      ),
    ),
  );

  const renderMedia = () => {
    if (currentStep.gallery) return h("div", { className: "creon-media creon-gallery" },
      h(MediaCard, { src: assetPath("pack-a.jpg"), label: ui.packA, missing: ui.missing }),
      h(MediaCard, { src: assetPath("pack-b.jpg"), label: ui.packB, missing: ui.missing }),
      h(MediaCard, { src: assetPath("pack-current.jpg"), label: ui.current, missing: ui.missing }),
    );
    if (!currentStep.asset) return null;
    return h("div", { className: "creon-media" },
      h(MediaCard, { src: assetPath(currentStep.asset), label: currentStep.concept ? `${ui.visual} · ${currentStep.concept}` : ui.visual, missing: ui.missing }),
      currentStep.type === "timedInfo" && timerRemaining > 0 && h("div", { className: "creon-timer" }, ui.seconds(timerRemaining)),
    );
  };

  const renderInput = () => {
    if (["info", "timedInfo"].includes(currentStep.type)) return null;
    if (["radio", "checkbox"].includes(currentStep.type)) {
      const multi = currentStep.type === "checkbox";
      const selected = multi ? (Array.isArray(draft) ? draft : []) : draft;
      return h(React.Fragment, null,
        h("div", { className: "creon-options" }, currentOptions.map((option) => h("label", { className: "creon-opt", key: option.code },
          h("input", {
            type: multi ? "checkbox" : "radio", name: currentStep.id, value: option.code,
            checked: multi ? selected.includes(option.code) : selected === option.code,
            onChange: (event) => multi ? handleCheckbox(option.code, event.target.checked) : (setDraft(option.code), setError("")),
          }),
          h("span", { className: "creon-opt-code" }, option.code), h("span", null, localized(option, language)),
        ))),
        currentStep.otherCode && (multi ? selected.includes(currentStep.otherCode) : selected === currentStep.otherCode) && h("div", { className: "creon-other" },
          h("textarea", { className: "creon-field", maxLength: 300, placeholder: ui.other, value: otherDraft, onChange: (event) => setOtherDraft(event.target.value) }),
        ),
      );
    }
    if (currentStep.type === "number") return h("input", { className: "creon-field", type: "number", min: 1, max: 120, inputMode: "numeric", placeholder: ui.age, value: draft, onChange: (event) => setDraft(event.target.value) });
    if (currentStep.type === "text") return h(React.Fragment, null,
      h("textarea", { className: "creon-field", maxLength: 800, placeholder: ui.placeholder, value: draft, onChange: (event) => setDraft(event.target.value) }),
      h("div", { className: "creon-counter" }, `${String(draft || "").length}/800`),
    );
    if (currentStep.type === "rating") return h("div", { className: "creon-options" }, currentStep.scale.map((number) => h("label", { className: "creon-opt", key: number },
      h("input", { type: "radio", name: currentStep.id, value: number, checked: String(draft) === String(number), onChange: () => setDraft(String(number)) }),
      h("span", { className: "creon-opt-code" }, number),
      h("span", null, number === currentStep.scale[0] ? ui.scaleLow : number === currentStep.scale[currentStep.scale.length - 1] ? ui.scaleHigh : ""),
    )));
    if (currentStep.type === "matrix") {
      const columns = currentStep.choices || currentStep.scale.map((number) => ({ code: String(number), ru: String(number), en: String(number) }));
      return h("div", { className: "creon-matrix-wrap" }, h("table", { className: "creon-matrix" },
        h("thead", null, h("tr", null, h("th", null), ...columns.map((column) => h("th", { key: column.code }, localized(column, language))))),
        h("tbody", null, ...currentItems.map((item, rowIndex) => h("tr", { key: item.code },
          h("td", null, localized(item, language)),
          ...columns.map((column) => h("td", { key: column.code }, h("input", {
            type: "radio", name: `${currentStep.id}_row_${rowIndex}`, value: column.code,
            checked: String((draft || {})[item.code]) === String(column.code),
            "aria-label": `${localized(item, language)}: ${localized(column, language)}`,
            onChange: () => setDraft((value) => ({ ...(value || {}), [item.code]: column.code })),
          }))),
        ))),
      ));
    }
    return null;
  };

  if (["starting", "camera", "active", "error"].includes(calibrationStatus)) {
    const completedCalibrationClicks = calibrationCounts.reduce((total, count) => total + count, 0);
    const totalCalibrationClicks = CALIBRATION_POINTS.length * CALIBRATION_CLICKS_PER_POINT;
    const calibrationReady = facePresenceStatus === "present" && eyeVisibilityStatus === "clear";
    const cameraStatusClass = facePresenceStatus === "missing"
      ? "missing"
      : eyeVisibilityStatus === "blocked"
        ? "blocked"
        : calibrationReady
          ? "present"
          : "checking";
    const cameraStatusText = facePresenceStatus === "missing"
      ? ui.faceMissing
      : eyeVisibilityStatus === "blocked"
        ? ui.eyewearBlocked
        : calibrationReady
          ? ui.faceReady
          : facePresenceStatus === "present"
            ? ui.eyewearChecking
            : ui.faceChecking;
    const calibrationWarning = facePresenceStatus === "missing"
      ? { title: ui.faceMissingTitle, body: ui.faceMissingBody }
      : eyeVisibilityStatus === "blocked"
        ? { title: ui.eyewearWarningTitle, body: ui.eyewearWarningBody }
        : null;

    return h("div", { className: "creon-survey", lang: language }, h("style", null, SURVEY_CSS),
      h("div", { className: "creon-calibration-screen" },
        h("section", { className: "creon-calibration-panel" },
          h("h1", null, calibrationStatus === "active" ? ui.calibrationTitle : calibrationStatus === "camera" ? ui.cameraReadyTitle : ui.calibrationTitle),
          calibrationStatus === "starting" && h(React.Fragment, null,
            h("p", null, ui.cameraStarting),
            h("div", { className: "creon-calibration-spinner", role: "status", "aria-label": ui.cameraStarting }),
          ),
          calibrationStatus === "camera" && h(React.Fragment, null,
            h("p", null, ui.cameraReadyBody),
            h("div", { className: "creon-recording-notice", role: "note" }, `● ${ui.recordingNotice}`),
            h("strong", { className: "creon-guide-title" }, ui.guideTitle),
            h("div", { className: "creon-guide-grid", role: "list" },
              h("div", { className: "creon-guide-card", role: "listitem" },
                h("span", { className: "creon-guide-icon", "aria-hidden": "true" }, "▣"),
                h("div", { className: "creon-guide-copy" },
                  h("strong", null, ui.cameraGuideTitle),
                  h("span", null, ui.cameraGuideBody),
                ),
              ),
              h("div", { className: "creon-guide-card", role: "listitem" },
                h("span", { className: "creon-guide-icon", "aria-hidden": "true" }, "◉"),
                h("div", { className: "creon-guide-copy" },
                  h("strong", null, ui.visibilityGuideTitle),
                  h("span", null, ui.visibilityGuideBody),
                ),
              ),
              h("div", { className: "creon-guide-card", role: "listitem" },
                h("span", { className: "creon-guide-icon", "aria-hidden": "true" }, "◎"),
                h("div", { className: "creon-guide-copy" },
                  h("strong", null, ui.calibrationGuideTitle),
                  h("span", null, ui.calibrationGuideBody),
                ),
              ),
            ),
            h("div", { className: `creon-face-status ${cameraStatusClass}` }, cameraStatusText),
            h("button", {
              type: "button",
              className: "creon-btn creon-btn-primary",
              disabled: !calibrationReady,
              onClick: showCalibrationPoints,
            }, ui.startCalibration),
          ),
          calibrationStatus === "active" && h(React.Fragment, null,
            h("p", null, ui.calibrationBody),
            h("div", { className: "creon-calibration-reminder", "aria-label": ui.calibrationBody },
              h("span", null, h("b", { "aria-hidden": "true" }, "●"), ui.reminderStill),
              h("span", null, h("b", { "aria-hidden": "true" }, "◎"), ui.reminderLook),
              h("span", null, h("b", { "aria-hidden": "true" }, "×5"), ui.reminderClick),
            ),
            h("strong", null, ui.calibrationProgress(completedCalibrationClicks, totalCalibrationClicks)),
          ),
          calibrationStatus === "error" && h(React.Fragment, null,
            h("div", { className: "creon-alert" }, calibrationError || ui.calibrationError),
            h("button", { type: "button", className: "creon-btn creon-btn-primary", onClick: startWebGazerCalibration }, ui.retryCalibration),
          ),
        ),
        calibrationStatus === "active" && calibrationWarning && h("div", { className: "creon-face-warning", role: "alert" },
          h("strong", null, calibrationWarning.title),
          h("span", null, calibrationWarning.body),
        ),
        calibrationStatus === "active" && CALIBRATION_POINTS.map((point, index) => {
          const count = calibrationCounts[index];
          const done = count >= CALIBRATION_CLICKS_PER_POINT;
          return h("button", {
            key: `${point.x}-${point.y}`,
            type: "button",
            className: `creon-calibration-point${done ? " done" : ""}`,
            style: { left: `${point.x}%`, top: `${point.y}%` },
            disabled: done || !calibrationReady,
            "aria-label": `${ui.calibrationTitle}: ${index + 1}`,
            onClick: (event) => handleCalibrationPoint(index, event),
          }, h("span", null, done ? "✓" : CALIBRATION_CLICKS_PER_POINT - count));
        }),
      ),
    );
  }

  if (endStatus) return h("div", { className: "creon-survey", lang: language }, h("style", null, SURVEY_CSS),
    h("main", { className: "creon-shell" }, h("section", { className: "creon-card" },
      h("h1", { className: "creon-question" }, ui.screenTitle),
      h("p", null, endStatus === "completed" ? ui.saved : ui.screened),
      h("div", { className: "creon-media-card" }, h("strong", null, ui.reference), h("div", { style: { fontSize: 26, marginTop: 8, letterSpacing: ".08em" } }, reference.current)),
    )),
  );

  const progress = Math.round(((currentIndex + 1) / steps.length) * 100);
  const trackingWarning = facePresenceStatus === "missing"
    ? { title: ui.faceMissingTitle, body: ui.faceMissingBody }
    : eyeVisibilityStatus === "blocked"
      ? { title: ui.eyewearWarningTitle, body: ui.eyewearWarningBody }
      : null;
  return h("div", { className: "creon-survey", lang: language },
    h("style", null, SURVEY_CSS),
    calibrationStatus === "completed" && trackingWarning && h("div", { className: "creon-face-warning", role: "alert" },
      h("strong", null, trackingWarning.title),
      h("span", null, trackingWarning.body),
    ),
    h("main", { className: "creon-shell" },
      h("div", { className: "creon-topbar" },
        h("div", { className: "creon-lang", role: "group", "aria-label": "Language" },
          h("button", { type: "button", className: language === "en" ? "active" : "", onClick: () => setLanguage("en") }, "EN"),
          h("button", { type: "button", className: language === "ru" ? "active" : "", onClick: () => setLanguage("ru") }, "RU"),
        ),
      ),
      h("section", { className: "creon-card", "aria-live": "polite" },
        error && h("div", { className: "creon-alert" }, error),
        h("div", { className: "creon-eyebrow" }, h("span", null, ui.section), h("span", { className: "creon-code" }, currentStep.id.replace(/_/g, " · "))),
        h("h1", { className: "creon-question" }, localized(currentStep.q, language)),
        isTrackedQuestion && !timersDone[currentStep.id] && !gazeRecordingReady
          ? h("div", { className: "creon-tracking-status" }, ui.trackingPreparing)
          : renderMedia(),
        renderInput(),
        h("div", { className: "creon-actions" },
          navigation.length > 0 && h("button", { type: "button", className: "creon-btn creon-btn-secondary", disabled: saving, onClick: handleBack }, ui.back),
          h("div", { className: "creon-spacer" }),
          h("button", { type: "button", className: "creon-btn creon-btn-primary", disabled: !isValid || saving, onClick: handleNext }, pendingSubmission ? ui.retry : ["info", "timedInfo"].includes(currentStep.type) ? ui.continue : ui.next),
        ),
        h("div", { className: "creon-progress", role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": progress }, h("div", { style: { width: `${progress}%` } })),
        h("div", { className: "creon-progress-text" }, `${ui.question} ${currentIndex + 1} ${ui.of} ${steps.length}`),
      ),
    ),
    saving && h("div", { className: "creon-loading", role: "status", "aria-live": "polite" }, h("div", { className: "creon-spinner" })),
  );
}
